import {

  BASE_API_URL,
  REACT_APP_BASE_API_FILTER_URL,
  WEB_TRACK_URL,
  QUALIFY_URL,
  ADMIN_CONFIG_URL,
  MDQS_BASEURL,
  TRANSFORM_URL,
  EXTRACT_URL,
  SYNC_URL,
  WEB_TRACK_URL_FOR_DOMAIN_UPDATE,
  CONTACT_INSERT_UPDATE_URL,
  IMPORT_URL,
  ML_BASE_URL,
  HPM_CONFIG_BASE_URL,
  SPROUTS_AGENT_BASE_ENDPOINT,
  RULE_DEFINITION_URL,
  CREDITS_BASE_URL,
  EXTRACT_URL_V2,
  RULE_DEFINITION_URL_V1,
  EXTRACT_URL_V3,
  NOTIFICATIONS_BASE_URL,
  LOGO_BASE_URL,
  AKMS_BASE_URL,
} from './env';

export const LOGIN = `${BASE_API_URL}/login`;
export const SPROUTS_LOGIN = `${BASE_API_URL}/sprous-login`;
export const GET_USER_CUSTOMER_DETAILS = `${REACT_APP_BASE_API_FILTER_URL}/getUserCustomerDetails`;
export const OAUTH_LOGIN = `${BASE_API_URL}/oauth-validation`;

// In-house SAML/OIDC SSO (no third-party broker) — see docs/sso-integration-plan.md
export const SSO_STATUS = `${BASE_API_URL}/organizations/sso-status`;
export const SSO_SESSION_BASE = `${BASE_API_URL}/auth/sso/session`;
export const SSO_SESSION = (sessionToken: string) =>
  `${SSO_SESSION_BASE}/${encodeURIComponent(sessionToken)}`;
// Full-page redirects, not axios calls — Spring Security's oauth2Login()/saml2Login()
// filters own these paths directly, one per protocol.
export const SSO_OIDC_AUTHORIZE = (registrationId: string) =>
  `${BASE_API_URL}/oauth2/authorization/${registrationId}`;
export const SSO_SAML_AUTHORIZE = (registrationId: string) =>
  `${BASE_API_URL}/saml2/authenticate/${registrationId}`;
// organizationUniqueId — same tenant identifier as useProfile()'s customerId, not the internal numeric id.
export const SSO_CONFIG = (organizationUniqueId: string) =>
  `${BASE_API_URL}/organizations/${organizationUniqueId}/sso-config`;

export const RESET_PASSWORD = `${BASE_API_URL}/resetPassword`;
export const FORGOT_PASSWORD = `${BASE_API_URL}/forgotPassword/email`;
// Intercom Messenger Security (Identity Verification) - backend should return { user_hash } or { intercom_user_jwt }
// Intercom Messenger Security (Identity Verification)
// Backend-provided endpoint (QA example: https://qacrm.sprouts.ai/ui/identity-verification)
export const INTERCOM_IDENTITY_VERIFICATION = `${REACT_APP_BASE_API_FILTER_URL}/identity-verification`;
export const GET_FILTER_DATA = `${REACT_APP_BASE_API_FILTER_URL}/getFilterData`;
export const GET_FILTER_DATA_FOR_CONTACT = `${REACT_APP_BASE_API_FILTER_URL}/getFilterDataForContact`;
export const GET_FILTER_DATA_FOR_ACCOUNT = `${REACT_APP_BASE_API_FILTER_URL}/getFilterDataForAccount`;
export const GET_FILTER_DATA_FOR_WEBSITE_ACCOUNT_LIST = `${REACT_APP_BASE_API_FILTER_URL}/getFiltersForWebsiteVisitors`;
export const GET_FILTER_DATA_FOR_WEBSITE_ACCOUNT_LIST_CONTACT = `${REACT_APP_BASE_API_FILTER_URL}/getFiltersForWebsiteContact`;
export const GET_CUSTOMER_FILTERED_MASTER_VIEW = `${REACT_APP_BASE_API_FILTER_URL}/getCustomerFilteredMasterView`;
export const GET_CUSTOMER_FILTERED_MASTER_VIEW_FOR_CONTACT = `${REACT_APP_BASE_API_FILTER_URL}/getCustomerFilteredMasterViewForContactFilter`;
export const GET_CUSTOMER_FILTERED_MASTER_VIEW_FOR_ACCOUNT = `${REACT_APP_BASE_API_FILTER_URL}/getCustomerFilteredMasterViewForAccountFilter`;
export const GET_IP_DETAILS_FOR_CUSTOMER = `${REACT_APP_BASE_API_FILTER_URL}/getIpDetailsForCustomer`;
export const INSERT_SINGLE_ACCOUNT = `${REACT_APP_BASE_API_FILTER_URL}/insertSingleAccount`;
export const INSERT_SINGLE_CONTACT = `${CONTACT_INSERT_UPDATE_URL}/insertSingleContact`;
export const MAP_CONTACT_REGION = `${REACT_APP_BASE_API_FILTER_URL}/multiChild/updateContactRegion`;
export const UPDATE_SINGLE_CONTACT = `${CONTACT_INSERT_UPDATE_URL}/updateSingleContact`;
export const GET_ACCOUNT_DETAIL_FROM_EMAIL = `${REACT_APP_BASE_API_FILTER_URL}/getAccountDetailFromEmail`;
export const REGISTER_CLIENT = `${BASE_API_URL}/registration`;
export const RESEND_INVITATION = `${BASE_API_URL}/resend`;

// Partner Management APIs
export const GET_PARTNERS = `${BASE_API_URL}/partner`;
export const CREATE_PARTNER = `${BASE_API_URL}/partner`;
export const GET_UNASSIGNED_TENANTS = `${BASE_API_URL}/partner/get-unassigned-customers`;
export const ASSIGN_TENANTS_TO_PARTNER = `${BASE_API_URL}/partner/assign-child-to-parent`;
export const UNASSIGN_TENANTS_FROM_PARTNER = `${BASE_API_URL}/partner/unassign-child-to-parent`;
export const GET_PARTNER_ASSIGNED_TENANTS = `${BASE_API_URL}/partner/get-child-of-parent`;

export const USER_REGISTRATION = `${BASE_API_URL}/invite-multiple-user`;
export const GET_MANAGE_USER_DETAILS = `${BASE_API_URL}/fetch-all`;
export const MANAGE_USER_STATUS_UPDATE = `${BASE_API_URL}/update-status`;
export const MANAGE_USER_DETAILS_UPDATE = `${BASE_API_URL}/update`;
export const GET_FILE_HEADER = `${IMPORT_URL}/getFileHeader`;
export const UPLOAD_DYNAMIC_DATA = `${IMPORT_URL}/uploadDynamicData`;
export const GET_USER_DETAILS = `${REACT_APP_BASE_API_FILTER_URL}/getUserDetails`;
export const GET_LIST_DETAILS = `${REACT_APP_BASE_API_FILTER_URL}/getListDetails`;
export const GET_VIEWLIST = `${REACT_APP_BASE_API_FILTER_URL}/viewList`;
export const CREATE_LIST = `${REACT_APP_BASE_API_FILTER_URL}/createList`;
export const CREATE_ICP = `${REACT_APP_BASE_API_FILTER_URL}/createICP`;
export const GET_ASSIGNED_TOPIC_LIST = `${REACT_APP_BASE_API_FILTER_URL}/getAssignedTopicList`;
export const GET_TOPIC_LIST = `${REACT_APP_BASE_API_FILTER_URL}/getTopicList`;
export const GET_WEEKLY_TOPIC_TREND = `${REACT_APP_BASE_API_FILTER_URL}/api/data/weekly-topic-trend`;
export const TRANSFER_PROFILE = `${REACT_APP_BASE_API_FILTER_URL}/completeTransfer`;
export const GET_ACCOUNT_DETAILS = `${REACT_APP_BASE_API_FILTER_URL}/account/find`;
export const UPDATE_CUSTOMER_TOPIC = `${REACT_APP_BASE_API_FILTER_URL}/updateCustomerTopicMapping`;
export const GENERATE_HPM = `${REACT_APP_BASE_API_FILTER_URL}/v3/send-contacts-for-hpm`;
export const GENERATE_HPM_FOR_FOLLOW_UPS = `${REACT_APP_BASE_API_FILTER_URL}/v3/generate-follow-up-message`;
export const GENERATE_HPM_FOR_LINKEDIN_FOLLOW_UPS = `${REACT_APP_BASE_API_FILTER_URL}/v3/generate-linkedin-follow-up-message`;
export const GENERATE_CALL_SCRIPT_MSG = `${REACT_APP_BASE_API_FILTER_URL}/v3/generate-call-script-message`;
export const REGENERATE_HPM = `${REACT_APP_BASE_API_FILTER_URL}/v3/regenerate-hpm-message`;
export const GENERATE_FRESH_HPM = `${REACT_APP_BASE_API_FILTER_URL}/v3/generate-fresh-message`;
export const SYNC_CONTACT_WITH_CMP = `${REACT_APP_BASE_API_FILTER_URL}/v3/sync-contact-with-cmp`;
export const GET_ALL_CUSTOM_PROMPT = `${REACT_APP_BASE_API_FILTER_URL}/v3/get-all-custom-prompt`;
export const CHECK_CONTACT_IN_SEQUENCE = `${REACT_APP_BASE_API_FILTER_URL}/v2/contact-sequence`;
export const RETRY_HPM = `${REACT_APP_BASE_API_FILTER_URL}/v3/retry-message-generate`;
export const SEND_MESSAGE_STATUS = `${REACT_APP_BASE_API_FILTER_URL}/v2/sendMessageStatus`;
export const GET_HPM_DATA = `${REACT_APP_BASE_API_FILTER_URL}/v3/contact-profile-data`;
export const IMPROVE_PROMPT = `${REACT_APP_BASE_API_FILTER_URL}/v3/validate-prompt`;
export const GET_HPM_MSG_DATA = `${REACT_APP_BASE_API_FILTER_URL}/v4/get-hpm-message`;
export const UPDATE_HPM_DATA = `${REACT_APP_BASE_API_FILTER_URL}/v3/update-message`;
export const SAVE_CUSTOM_PROMPT = `${REACT_APP_BASE_API_FILTER_URL}/v3/save-custom-prompt`;
export const DELETE_CUSTOM_PROMPT = `${REACT_APP_BASE_API_FILTER_URL}/v3/delete-custom-prompt`;
export const MARK_CUSTOM_PROMPT = `${REACT_APP_BASE_API_FILTER_URL}/v3/mark-favorite-custom-prompt`;
export const EDIT_CUSTOM_PROMPT = `${REACT_APP_BASE_API_FILTER_URL}/v3/edit-custom-prompt`;
export const MANAGE_PROFILE_GET_USER_DETAILS = `${BASE_API_URL}/getUserDetails`;
export const MANAGE_PROFILE_UPDATE_USER_DETAILS = `${BASE_API_URL}/update`;
export const GET_TRACK_KEY = `${WEB_TRACK_URL}/v1/customers/`;
export const EXPORT_VIEW_List_DATA = `${REACT_APP_BASE_API_FILTER_URL}/exportViewList`;
export const EXPORT_TARGET_PROFILES_DATA_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/exportTargetProfilesForContacts`;
export const EXPORT_TARGET_PROFILES_DATA_ACCOUNTS = `${REACT_APP_BASE_API_FILTER_URL}/exportTargetProfilesForAccounts`;
export const EXPORT_WEBSITE_VISTOR = `${REACT_APP_BASE_API_FILTER_URL}/exportWebsiteVisitor`;
export const QUALIFY_UPDATE_URL = `${QUALIFY_URL}/api/v2/qualify/update-status`;
export const UPDATE_AWS_DETAILS = `${BASE_API_URL}/update/aws/detail`;
export const GET_SUMMARY_VIEW = `${REACT_APP_BASE_API_FILTER_URL}/website/summery/details`;
export const GET_CUSTOMER_WEB_TRACKING_STATUS = `${REACT_APP_BASE_API_FILTER_URL}/getCustomerWebTrackingStatus`;
export const UPDATE_CUSTOMER_WEB_TRACKING_STATUS = `${REACT_APP_BASE_API_FILTER_URL}/updateCustomerWebTrackingStatus`;
export const UPDATE_ORG_INFO = `${BASE_API_URL}/updateOrgInfo`;
export const ADD_EXCLUSION_RECORD = `${REACT_APP_BASE_API_FILTER_URL}/exclude/addExclusionRecord`;
export const GET_COMPANY_NAME = `${REACT_APP_BASE_API_FILTER_URL}/exclude/getCompanyName`;
export const GET_ALL_EXCLUSION_RECORDS = `${REACT_APP_BASE_API_FILTER_URL}/exclude/getAllExclusionRecored`;
export const GET_EXCLUSION_RECORD_SEARCH = `${REACT_APP_BASE_API_FILTER_URL}/exclude/getAllExclusionRecoredByDomainKey`;
export const UPDATE_EXCLUSION_RECORD = `${REACT_APP_BASE_API_FILTER_URL}/exclude/updateExclusionRecord`;
export const DELETE_EXCLUSION_RECORD = `${REACT_APP_BASE_API_FILTER_URL}/exclude/deleteExclusionRecord`;
export const GET_CUSTOM_FIELDS_DATA = `${REACT_APP_BASE_API_FILTER_URL}/getCustomFields`;
export const SAVE_DATA_TO_CMP = `${REACT_APP_BASE_API_FILTER_URL}/cmp/add-to-cmp-sequence`;
export const GET_CRM_SEQUENCES = `${REACT_APP_BASE_API_FILTER_URL}/cmp/sequences`;

export const SET_EXCLUSION_RECORD = `${REACT_APP_BASE_API_FILTER_URL}/exclude/setExclusionRecord`;
export const SET_Dynamic_EXCLUSION_RECORD = `${REACT_APP_BASE_API_FILTER_URL}/exclude/setDynamicExclusionRecord`;
export const GET_FEATURES = `${ADMIN_CONFIG_URL}/customer/features`;
export const SAVE_CODE = `${ADMIN_CONFIG_URL}/oauth/save-code`;
export const DISCONNECT_SCHEDULE = `${ADMIN_CONFIG_URL}/oauth/disconnect-integration`;
export const ADD_CRM_OBJECT = `${ADMIN_CONFIG_URL}/crm-object-properties/add`;
export const GET_CRM_OBJECT_PROPERTIES = `${ADMIN_CONFIG_URL}/crm-object-properties`;
export const MAP_VALUES_FETCH = `${ADMIN_CONFIG_URL}/map-values-fetch`;
export const MAP_VALUES = `${ADMIN_CONFIG_URL}/map-values`;
export const CRM_DROPDOWN_VALUES = `${ADMIN_CONFIG_URL}/crm/dropdown-values`;
export const GET_CRM_STAGES = `${ADMIN_CONFIG_URL}/getStagesByCustomerIdAndOperation`;
export const GET_CRM_MAPPINGS = `${ADMIN_CONFIG_URL}/crm-mappings`;
export const SYNC_MANUAL_TRIGGER_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/crm/sync-contacts-manual-trigger`;
export const UPDATE_CRM_MAPPING = `${ADMIN_CONFIG_URL}/crm-sprouts-properties/map`;
export const GET_SANDBOX_ENABLE = `${ADMIN_CONFIG_URL}/sandbox-enable`;
export const UPDATE_SANDBOX_ENABLE = `${ADMIN_CONFIG_URL}/customer-feature-flag/enable`;
export const GET_CUSTOMER_ID = `${ADMIN_CONFIG_URL}/customer`;
export const GET_PUT_INTEGRATION_STATUS = `${ADMIN_CONFIG_URL}/oauth/integration-status`;
export const VALIDATE_CREDENTIALS = `${ADMIN_CONFIG_URL}/oauth/validateCredentials`;
export const GLOBAL_SYNC_FLAG = `${ADMIN_CONFIG_URL}/global-sync-flag`;
export const GET_CONNECTED_CMP_LIST = `${ADMIN_CONFIG_URL}/customer-cmp-providers`;
export const FETCH_ACTIVE_INTEGRATIONS = `${ADMIN_CONFIG_URL}/fetch-active-integration`;
export const GET_CMP_MAILBOXES = `${ADMIN_CONFIG_URL}/cmp/mailboxes`;
export const POST_TEST_RUN = `${TRANSFORM_URL}/batch/transform`;
export const BATCH_EXTRACT = `${EXTRACT_URL}/batch/extract`;
export const BATCH_EXTRACT_V2 = `${EXTRACT_URL_V2}/batch/extract`;
export const BATCH_EXTRACT_V3 = `${EXTRACT_URL_V3}/batch/extract`;
export const GET_ERROR_CSV = `${TRANSFORM_URL}/error-csv`;
export const GET_SYNC_DATA = `${SYNC_URL}/jobs`;
export const SCHEDULE_SYNC = `${SYNC_URL}/schedules`;
export const GET_SCHEDULES = `${SYNC_URL}/schedules/global`;
export const QUALIFY_ACCOUNTS_TO_TARGET_PROFILES = `${MDQS_BASEURL}/v1/target_profiles/accounts`;
export const QUALIFY_CONTACTS_TO_TARGET_PROFILES = `${MDQS_BASEURL}/v1/target_profiles/contacts`;
export const BULK_MOVE_TO_TAL = `${MDQS_BASEURL}/v1/target_profiles/contacts/bulk_save`;
export const TECHNOLOGY_FROM_ES = `${REACT_APP_BASE_API_FILTER_URL}/technologies/from-es`;
export const FETCH_APOLLO_LOCATIONS = `${MDQS_BASEURL}/v1/filters/tags/company_location?page=1&page_size=25&search_text=`;
export const get_MDQS_FILTERS = (db: string) =>
  `${MDQS_BASEURL}/v1/search/filters?databaseName=${db}`;
export const get_MDQS_ACCOUNTS = (db: string) =>
  `${MDQS_BASEURL}/v1/accounts/search?databaseName=${db}`;
export const get_MDQS_CONTACTS = (db: string) =>
  `${MDQS_BASEURL}/v1/contacts/search?databaseName=${db}`;
export const update_AllOWED_DOMAINS = (clientKeyData: string) =>
  `${WEB_TRACK_URL_FOR_DOMAIN_UPDATE}/v1/customers/${clientKeyData}/updateAllowedDomains`;

export const MDQS_HEADERS_BASE_URL = `${REACT_APP_BASE_API_FILTER_URL}/v1/data_query_columns`;
export const MDQS_ACCOUNT_RESULT_COUNTS = `${MDQS_BASEURL}/v1/accounts/search_counts`;
export const MDQS_CONTACT_RESULT_COUNTS = `${MDQS_BASEURL}/v1/contacts/search_counts`;
export const SAVE_SEARCHES_BASE = `${MDQS_BASEURL}/v1/search_filters`;
export const GET_CONTACT_DETAILS = `${MDQS_BASEURL}/v1/contacts/details`;

export const GET_CUSTOMER_ICP_FILTERS_FOR_SALES_DEMO = `${REACT_APP_BASE_API_FILTER_URL}/demoApi/getCustomerICPFilters`;
export const CREATE_CUSTOMER_ICP_FILTERS_FOR_SALES_DEMO = `${REACT_APP_BASE_API_FILTER_URL}/demoApi/createICPFilters`;
export const GET_LIST_NAME_BY_KEY = `${REACT_APP_BASE_API_FILTER_URL}/getListNameByKey`;
export const GET_LISTNAMES_BELONG_TO_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/getListNameBelongsToContact`;
export const DELETE_LIST = `${REACT_APP_BASE_API_FILTER_URL}/deleteList`;

export const GET_CUSTOMER_ICPS = `${REACT_APP_BASE_API_FILTER_URL}/getICPViewFilter`;
export const GET_CUSTOMER_ICPS_LIST = `${REACT_APP_BASE_API_FILTER_URL}/customerICP/list`;
export const GET_CUSTOMER_WIIFT = `${REACT_APP_BASE_API_FILTER_URL}/customer-wiift/get-ppfo`;
export const ADD_CUSTOMER_WIIFT = `${REACT_APP_BASE_API_FILTER_URL}/customer-wiift/save-ppfo`;
export const TRIGGER_WIIFT = `${REACT_APP_BASE_API_FILTER_URL}/customer-wiift/enrich`;
export const TRIGGER_INTENT_TOPICS_WIIFT = `${REACT_APP_BASE_API_FILTER_URL}/customer-wiift/enrich/intent-topic`;
export const CANCEL_TRIGGER_WIIFT = `${REACT_APP_BASE_API_FILTER_URL}/customer-wiift/cancel-enrich`;
export const TRIGGER_WIIFT_STATUS = `${REACT_APP_BASE_API_FILTER_URL}/customer-wiift/status`;
export const TRIGGER_WIIFT_STATUS_STREAM = `${REACT_APP_BASE_API_FILTER_URL}/customer-wiift/status/stream`;
export const SSE_STREAM_URL = `${REACT_APP_BASE_API_FILTER_URL}/v1/sse/stream`;
export const DELETE_AI_GENERATED_INTENT_TOPICS = `${REACT_APP_BASE_API_FILTER_URL}/customer-wiift/delete-intent-topics`;
export const DELETE_WIIFT = `${REACT_APP_BASE_API_FILTER_URL}/customer-wiift/delete-ppfo`;
export const GET_COMPANY_MDQS = `${MDQS_BASEURL}/v1/search/filters/companies?databaseName=sprouts&page=1&page_size=50&search_text=`;
export const GET_ACTIVE_CUSTOMERS = `${REACT_APP_BASE_API_FILTER_URL}/customer-wiift/exist-active-customer`;
export const DELETE_ACTIVE_CUSTOMERS = `${REACT_APP_BASE_API_FILTER_URL}/customer-wiift/delete-active-customer`;
export const GET_PRODUCT_SERVICE_LIST = `${HPM_CONFIG_BASE_URL}/hpm-product-service/list`;
export const HPM_SAVE_PRODUCT_SERVICE = `${HPM_CONFIG_BASE_URL}/hpm-product-service/save`;
export const HPM_EDIT_PRODUCT_SERVICE = `${HPM_CONFIG_BASE_URL}/hpm-product-service/update`;
export const HPM_DELETE_PRODUCT_SERVICE = `${HPM_CONFIG_BASE_URL}/hpm-product-service/delete`;
export const HPM_DELETE_BULK_PPFOS = `${HPM_CONFIG_BASE_URL}/customer-wiift/v1/delete-ppfo`;
export const HPM_ADD_TESTIMONIAL = `${HPM_CONFIG_BASE_URL}/testimonials/add`;
export const HPM_EDIT_TESTIMONIAL = `${HPM_CONFIG_BASE_URL}/testimonials/edit`;
export const HPM_DELETE_BULK_TESTIMONIALS = `${HPM_CONFIG_BASE_URL}/testimonials/delete`;
export const GET_HPM_FILE_CONTENT_LIST = `${HPM_CONFIG_BASE_URL}/hpm-file-content/list`;
export const HPM_SAVE_FILE_CONTENT = `${HPM_CONFIG_BASE_URL}/hpm-file-content/save`;
export const HPM_EDIT_FILE_CONTENT = `${HPM_CONFIG_BASE_URL}/hpm-file-content/edit`;
export const HPM_DELETE_FILE_CONTENT = `${HPM_CONFIG_BASE_URL}/hpm-file-content/delete`;
export const HPM_REFRESH_FILE_CONTENT = `${HPM_CONFIG_BASE_URL}/hpm-file-content/refresh`;
export const HPM_FETCH_FILE_CONTENT_CONTEXT = `${HPM_CONFIG_BASE_URL}/hpm-file-content/fetch-context`;
export const HPM_FETCH_FILE_CONTENT_EXTRACTED_ENTITIES = `${ML_BASE_URL}/graph/graph/document`;

// Customer System Prompt APIs
export const CUSTOMER_SYSTEM_PROMPT_CREATE = `${HPM_CONFIG_BASE_URL}/customer-system-prompt/create`;
export const CUSTOMER_SYSTEM_PROMPT_UPDATE = `${HPM_CONFIG_BASE_URL}/customer-system-prompt/update`;
export const CUSTOMER_SYSTEM_PROMPT_DELETE_BATCH = `${HPM_CONFIG_BASE_URL}/customer-system-prompt/delete/batch`;

// Recommended Signals APIs
export const CUSTOMER_SIGNAL_CREATE = `${HPM_CONFIG_BASE_URL}/customer-signal/create`;
export const CUSTOMER_SIGNAL_GET_ALL = `${HPM_CONFIG_BASE_URL}/customer-signal/get-all`;
export const CUSTOMER_SIGNAL_GET = `${HPM_CONFIG_BASE_URL}/customer-signal/get`;
export const CUSTOMER_SIGNAL_UPDATE = `${HPM_CONFIG_BASE_URL}/customer-signal/update`;
export const CUSTOMER_SIGNAL_DELETE = `${HPM_CONFIG_BASE_URL}/customer-signal/delete`;
export const CUSTOMER_SIGNAL_DELETE_BATCH = `${HPM_CONFIG_BASE_URL}/customer-signal/delete/batch`;

// HPM Recommended Intent Topics APIs
export const HPM_RECOMMENDED_INTENT_TOPICS_LIST = `${REACT_APP_BASE_API_FILTER_URL}/customer-wiift/intent-topics/list`;
export const HPM_RECOMMENDED_INTENT_TOPICS_SAVE = `${REACT_APP_BASE_API_FILTER_URL}/customer-wiift/intent-topics/save`;
export const HPM_RECOMMENDED_INTENT_TOPICS_EDIT = `${REACT_APP_BASE_API_FILTER_URL}/customer-wiift/intent-topics/edit`;
export const HPM_RECOMMENDED_INTENT_TOPICS_DELETE = `${REACT_APP_BASE_API_FILTER_URL}/customer-wiift/delete-topic-detail`;

export const EDIT_ICP_FILTER_STATUS = `${REACT_APP_BASE_API_FILTER_URL}/editICPFilterStatus`;
export const GET_ICP_FILTERS = `${REACT_APP_BASE_API_FILTER_URL}/load/icp/filters`;
export const CREATE_ICP_FILTERS = `${REACT_APP_BASE_API_FILTER_URL}/createICPFilter`;
export const DELETE_ICP_FILTERS = `${REACT_APP_BASE_API_FILTER_URL}/deleteICPFilter`;
export const SET_DEFAULT_FILTER_FOR_ICP = `${REACT_APP_BASE_API_FILTER_URL}/set-default-filter`;
export const GET_ICP_FILTERS_BY_ID = `${REACT_APP_BASE_API_FILTER_URL}/getICPViewFilterById`;
export const UPDATE_ICP_FILTER = `${REACT_APP_BASE_API_FILTER_URL}/editICPViewFilter`;
export const CLONE_ICP_FILTER = `${REACT_APP_BASE_API_FILTER_URL}/cloneICPFilter`;
export const REMOVE_CONTACT_FROM_LIST = `${REACT_APP_BASE_API_FILTER_URL}/contactRemoveFromList`;
export const FETCH_ENUM_VALUES = `${REACT_APP_BASE_API_FILTER_URL}/fetch-enum-values`;

export const get_WEBSITE_VISIT_DATA = `${REACT_APP_BASE_API_FILTER_URL}/websiteVisitData`;
export const CONTACTS_ENGAGED = `${REACT_APP_BASE_API_FILTER_URL}/contactsEngagedAndCampaignStage`;
export const get_UNIQUE_PAGE_VISITS_DATES = (domain: string, userTimezone: string) =>
  `${WEB_TRACK_URL}/v1/iplookups/domains/${domain}/visitDates?time_zone=${userTimezone}`;
export const get_UNIQUE_IP_LOCATIONS = (domain: string, date: string, userTimezone: string) =>
  `${WEB_TRACK_URL}/v1/iplookups/domains/${domain}/visitDates/${date}?time_zone=${userTimezone}`;
export const get_PAGE_VISITS_FOR_DOMAIN = (domain: string, date: string, userTimezone: string) =>
  `${WEB_TRACK_URL}/v1/iplookups/domains/${domain}/visitDates/${date}/ipLocations?time_zone=${userTimezone}`;
export const get_PAGE_VISITS_FOR_DOMAIN_BY_DATE_RANGE = (
  domain: string,
  fromDate: string,
  toDate: string,
) =>
  `${WEB_TRACK_URL}/v1/iplookups/domains/${domain}/pageVisits?fromDate=${fromDate}&toDate=${toDate}`;
export const get_AGGREGATED_HITS = (
  domain: string,
  aggregationType: string,
  fromDate: string,
  toDate: string,
) =>
  `${WEB_TRACK_URL}/v1/iplookups/${domain}/aggregated_hits?aggregationType=${aggregationType}&fromDate=${encodeURIComponent(
    fromDate,
  )}&toDate=${encodeURIComponent(toDate)}`;
export const get_ENGAGEMENT_SCORE_GRAPH = (
  customerId: string,
  domain: string,
  fromDate: string,
  toDate: string,
  aggregationType: string,
) =>
  `${REACT_APP_BASE_API_FILTER_URL}/api/engagement/score/graph?customerId=${customerId}&domain=${domain}&fromDate=${encodeURIComponent(
    fromDate,
  )}&toDate=${encodeURIComponent(toDate)}&aggregationType=${aggregationType}`;
export const SUPERSET_DOMAIN_DATA = `${REACT_APP_BASE_API_FILTER_URL}/getDomainInfo`;
export const SUPERSET_LOGIN = `${REACT_APP_BASE_API_FILTER_URL}/loginDashboard`;

export const UPDATE_ACCOUNT_OWNER = `${REACT_APP_BASE_API_FILTER_URL}/updateAccountOwner`;
export const UPDATE_CONTACT_OWNER = `${REACT_APP_BASE_API_FILTER_URL}/updateContactOwner`;

export const ADD_CUSTOM_FIELD = `${REACT_APP_BASE_API_FILTER_URL}/dynamic/column`;
export const EDIT_CUSTOM_FIELD = `${REACT_APP_BASE_API_FILTER_URL}/update/dynamic/column`;
export const EDIT_CUSTOM_FIELD_OPTIONS = `${REACT_APP_BASE_API_FILTER_URL}/update/dynamic/options`;
export const VALIDATE_CUSTOM_FIELD = `${REACT_APP_BASE_API_FILTER_URL}/check/fieldName`;
export const CUSTOM_FIELDS_LISTING_ALL_FIELDS = `${REACT_APP_BASE_API_FILTER_URL}/findAll/dynamic/columns`;
export const CUSTOM_FIELDS_DELETE = `${REACT_APP_BASE_API_FILTER_URL}/delete/dynamic/column`;
export const GET_CUSTOM_FIELDS_HEADER_LIST = `${REACT_APP_BASE_API_FILTER_URL}/get/header/list`;
export const GET_DYNAMIC_COLUMNS_OF_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/get/contact/headers`;
export const GET_DYNAMIC_COLUMNS_OF_ACCOUNTS = `${REACT_APP_BASE_API_FILTER_URL}/get/account/headers`;
export const GET_SINGLE_CONTACT_DETAILS = `${REACT_APP_BASE_API_FILTER_URL}/getContactDetails`;
export const GET_CUSTOM_FIELDS_COUNT = `${REACT_APP_BASE_API_FILTER_URL}/countCustomFields`;
export const GET_COMPANY_ENTITY_INFO = `${REACT_APP_BASE_API_FILTER_URL}/getCompanyEntityInfo`;
export const GET_CONTACT_ENTITY_INFO = `${REACT_APP_BASE_API_FILTER_URL}/getContactsEntityInfo`;
export const GET_RECOMMENDED_ICP = `${REACT_APP_BASE_API_FILTER_URL}/getCustomerScoreConfig`;
export const ICP_TRAIN_TRIGGER = `${REACT_APP_BASE_API_FILTER_URL}/icp/trigger`;
export const ICP_ACTIVE_STATE = `${REACT_APP_BASE_API_FILTER_URL}/icp/active-state`;
export const CLONE_AI_ICP = `${REACT_APP_BASE_API_FILTER_URL}/clone-ai-icp`;
export const GET_DOMAIN_WISE_PAGE_COUNT = `${WEB_TRACK_URL}/v1/pages/domain_wise_count`;
export const GET_LIST_OF_CATEGORIES = `${WEB_TRACK_URL_FOR_DOMAIN_UPDATE}/v1/pages/categories`;
export const GET_LIST_OF_PAGES = `${WEB_TRACK_URL_FOR_DOMAIN_UPDATE}/v1/pages`;
export const GET_TOP_VISITING_DOMAINS = `${WEB_TRACK_URL}/v1/pages/top_visiting_domains`;
export const GET_CSV_EXPORT_OF_PAGES = `${WEB_TRACK_URL}/v1/pages/csv_export`;
export const UPDATE_MULTIPLE_MASTER_PAGES = `${WEB_TRACK_URL_FOR_DOMAIN_UPDATE}/v1/pages/bulk_update_funnel_stage`;
export const GET_VISITING_DOMAINS = `${WEB_TRACK_URL}/v1/pages/top_visiting_domains`;
export const update_SINGLE_MASTER_STAGE_FOR_PAGE = (page_id: string) =>
  `${WEB_TRACK_URL_FOR_DOMAIN_UPDATE}/v1/pages/${page_id}/update_funnel_stage`;
export const update_MASTER_LINK_STAGE_FOR_CATEGORY = (domain: string, category: string) =>
  `${WEB_TRACK_URL_FOR_DOMAIN_UPDATE}/v1/pages/categories/${category}/${domain}/update_funnel_stage`;

export const DELETE_CONTACTS_OR_ACCOUNTS = `${REACT_APP_BASE_API_FILTER_URL}/delete`;
export const UPDATE_SINGLE_ACCOUNT = `${REACT_APP_BASE_API_FILTER_URL}/updateSingleAccount`;
export const GET_SINGLE_ACCOUNT_DETAILS = `${REACT_APP_BASE_API_FILTER_URL}/getAccountDetails`;
export const ACCOUNTS_CONTACTS_BULK_EDIT = `${REACT_APP_BASE_API_FILTER_URL}/bulk-update`;
export const ICP_SCORING_FEEDBACK = `${REACT_APP_BASE_API_FILTER_URL}/isHelpful`;
export const GENERATE_AI_SIGNALS = `${REACT_APP_BASE_API_FILTER_URL}/webScraping`;
export const ADD_GENERATED_AI_SIGNALS = `${REACT_APP_BASE_API_FILTER_URL}/add/webScrapping`;
export const SEND_PERSONALIZED_EMAIL = `${REACT_APP_BASE_API_FILTER_URL}/sendPersonalizedEmail`;
export const GET_CONTACTS_IDS = `${REACT_APP_BASE_API_FILTER_URL}/getContactId`;
export const GET_ACCOUNTS_IDS = `${REACT_APP_BASE_API_FILTER_URL}/getCompanyId`;
export const GET_SHARE_FEEDBACK_URL = `${REACT_APP_BASE_API_FILTER_URL}/g2-form-url`;
export const GET_ACCOUNT_CONTACT_SOURCE_URL = `${IMPORT_URL}/crm/getCrmLink`;

export const GET_ALL_HEADERS = `${REACT_APP_BASE_API_FILTER_URL}/customized/headers/entity`;
export const GET_ACCOUNTS_ALL_HEADERS = `${REACT_APP_BASE_API_FILTER_URL}/customized/headers/entity`;
export const GET_WEBSITE_ALL_HEADERS = `${REACT_APP_BASE_API_FILTER_URL}/customized/headers/entity`;
export const UPDATE_CUSTOMISED_LAYOUT = `${REACT_APP_BASE_API_FILTER_URL}/update/layout`;
export const GET_CUSTOMISED_TAL_ACCOUNTS_DETAILS = `${REACT_APP_BASE_API_FILTER_URL}/getCustomizedTalAccountDetails`;
export const GET_CUSTOMISED_TAL_CONTACTS_DETAILS = `${REACT_APP_BASE_API_FILTER_URL}/getCustomizedTalContactDetails`;
export const CONTACT_REFRESH = `${REACT_APP_BASE_API_FILTER_URL}/v1/contacts/refresh`;
export const CONTACT_REFRESH_STATUS = `${REACT_APP_BASE_API_FILTER_URL}/v1/contacts/refresh/status`;
export const GET_CUSTOMISED_WEBSITE_IP_DETAILS = `${REACT_APP_BASE_API_FILTER_URL}/getIpDetailsForCustomer`;
export const GET_CUSTOMISED_WEBSITE_IP_DETAILS_CONTACT = `${REACT_APP_BASE_API_FILTER_URL}/website/revealed/contact`;
export const GET_DOMAIN_CONFIDENCE_SCORE = `${WEB_TRACK_URL}/v1/iplookups/domains/confidence_score`;
export const GET_DEFAULT_HEADERS = `${REACT_APP_BASE_API_FILTER_URL}/load/headers?entity=`;
export const GET_ACC_CONTACT_SELECTED_HEADERS = `${REACT_APP_BASE_API_FILTER_URL}/selected/headers`;

export const LIST_PLAYBOOKS = `${REACT_APP_BASE_API_FILTER_URL}/playbooks`;
export const SORT_PLAYBOOKS = `${REACT_APP_BASE_API_FILTER_URL}/playbooks/sort`;
export const PLAYBOOKS_BASE_URL = `${REACT_APP_BASE_API_FILTER_URL}/playbooks`;
export const CREATE_LIST_PLAYBOOK = `${REACT_APP_BASE_API_FILTER_URL}/playbooks/create-list`;
export const UPDATE_PLAYBOOK_STATUS_V2 = `${REACT_APP_BASE_API_FILTER_URL}/playbooks/update-status`;
export const UPDATE_PLAYBOOK_OWNER = `${REACT_APP_BASE_API_FILTER_URL}/playbooks/update-playbook-owner`;
export const VERIFY_PLAYBOOK_TEMPLATE_DETAILS = `${REACT_APP_BASE_API_FILTER_URL}/playbooks/verify-template-details`;
export const GET_TEMPLATE_DETAILS = `${REACT_APP_BASE_API_FILTER_URL}/playbooks/get-template-details`;
export const GET_PLAYBOOKS_TEMPLATES = `${REACT_APP_BASE_API_FILTER_URL}/playbook_templates`;
export const GET_CUSTOMER_TRACKING_SNIPPET = `${REACT_APP_BASE_API_FILTER_URL}/customer/tracking/snippet`;

// Workflow Data Mapping API Endpoints (Rule Definition Service)
export const WORKFLOW_DATA_MAPPING_BASE_URL = `${RULE_DEFINITION_URL_V1}/api/workflows`;
export const GET_NODE_TYPE_OUTPUT_SCHEMA = (nodeType: string) =>
  `${WORKFLOW_DATA_MAPPING_BASE_URL}/node-types/${nodeType}/output-schema`;
export const GET_NODE_SCHEMAS = `${WORKFLOW_DATA_MAPPING_BASE_URL}/node-schemas`;
export const GET_NODE_INSTANCE_OUTPUT_SCHEMA = (workflowId: string, nodeId: string) =>
  `${WORKFLOW_DATA_MAPPING_BASE_URL}/${workflowId}/nodes/${nodeId}/output-schema`;
export const GET_NODE_INPUT_SOURCES = (workflowId: string, nodeId: string) =>
  `${WORKFLOW_DATA_MAPPING_BASE_URL}/${workflowId}/nodes/${nodeId}/input-sources`;
export const UPDATE_PARAMETER_MAPPING = (workflowId: string, nodeId: string) =>
  `${WORKFLOW_DATA_MAPPING_BASE_URL}/${workflowId}/nodes/${nodeId}/parameter-mapping`;
export const VALIDATE_PARAMETER_MAPPING = (workflowId: string, nodeId: string) =>
  `${WORKFLOW_DATA_MAPPING_BASE_URL}/${workflowId}/nodes/${nodeId}/validate-mapping`;
export const GET_MAPPING_SUGGESTIONS = (workflowId: string, nodeId: string) =>
  `${WORKFLOW_DATA_MAPPING_BASE_URL}/${workflowId}/nodes/${nodeId}/mapping-suggestions`;
export const TEST_PARAMETER_MAPPING = `${WORKFLOW_DATA_MAPPING_BASE_URL}/test-mapping`;
export const GET_WORKFLOW_EXECUTION_CONTEXT = (workflowId: string, nodeId: string) =>
  `${WORKFLOW_DATA_MAPPING_BASE_URL}/${workflowId}/context/${nodeId}`;
export const GET_AVAILABLE_VARIABLES = (workflowId: string) =>
  `${WORKFLOW_DATA_MAPPING_BASE_URL}/${workflowId}/available-variables`;
export const RESOLVE_EXPRESSION = `${WORKFLOW_DATA_MAPPING_BASE_URL}/resolve-expression`;
export const EXECUTE_NODE = `${WORKFLOW_DATA_MAPPING_BASE_URL}/execute-node`;
export const GET_WORKFLOW_EXECUTION_STATUS = (workflowId: string) =>
  `${WORKFLOW_DATA_MAPPING_BASE_URL}/${workflowId}/status`;
export const GET_EXECUTION_LOGS = (workflowId: string, executionId?: string) =>
  executionId
    ? `${WORKFLOW_DATA_MAPPING_BASE_URL}/${workflowId}/executions/${executionId}/logs`
    : `${WORKFLOW_DATA_MAPPING_BASE_URL}/${workflowId}/logs`;
export const VALIDATE_WORKFLOW = (workflowId: string) =>
  `${WORKFLOW_DATA_MAPPING_BASE_URL}/${workflowId}/validate`;
export const STOP_WORKFLOW_EXECUTION = (workflowId: string, executionId: string) =>
  `${WORKFLOW_DATA_MAPPING_BASE_URL}/${workflowId}/executions/${executionId}/stop`;
export const START_WORKFLOW_EXECUTION = (workflowId: string) =>
  `${WORKFLOW_DATA_MAPPING_BASE_URL}/${workflowId}/execute`;
export const GET_TRIGGER_DATA_SCHEMA = (triggerType: string) =>
  `${WORKFLOW_DATA_MAPPING_BASE_URL}/trigger-schemas/${triggerType}`;

export const get_ICP_LIST_FOR_FILTER = (customerId: string) =>
  `${REACT_APP_BASE_API_FILTER_URL}/filter/getICPFilterNames/${customerId}`;
export const GET_ICP_SCORE_QUANTITY = (customerId: string, icpName: string) =>
  `${REACT_APP_BASE_API_FILTER_URL}/filter/fitmentScore?uniqueId=${customerId}&searchText=${icpName}`;
export const GET_ACCOUNT_DETAILS_FROM_DOMAIN = `${REACT_APP_BASE_API_FILTER_URL}/getAccountDetailFromDomain`;
export const GET_ACCOUNT_REGION_FROM_DOMAIN = `${REACT_APP_BASE_API_FILTER_URL}/multiChild/getRegion`;
export const VALIDATE_TOKEN = `${BASE_API_URL}/validate-token`;
export const GET_CREDIT_HISTORY_TABLE_DATA = `${CREDITS_BASE_URL}/v1/recharge_requests`;
export const GET_CREDIT = `${CREDITS_BASE_URL}/v1/credits/balance`;
export const CREATE_CREDIT = `${CREDITS_BASE_URL}/v1/recharge_requests/create_fulfil`;
export const GET_CREDIT_CONFIG = `${CREDITS_BASE_URL}/v1/credits/config`;
export const CREATE_SELF_RECHARGE = `${CREDITS_BASE_URL}/v1/recharge_requests/self`;
export const SEND_UPDATE_CREDIT_EMAIL = `${REACT_APP_BASE_API_FILTER_URL}/v1/credit/sendEmail`;

// Credit Usage & Recharge History APIs
export const GET_CREDIT_USAGE = `${CREDITS_BASE_URL}/v1/credits/usage`;
export const GET_CREDIT_USAGE_SUMMARY = `${CREDITS_BASE_URL}/v1/credits/usage/summary`;
export const GET_CREDIT_USAGE_EXPORT = `${CREDITS_BASE_URL}/v1/credits/usage/export`;
export const GET_CREDIT_USAGE_BY_ITEM = `${CREDITS_BASE_URL}/v1/credits/usage/by_item`;
export const GET_CREDIT_USAGE_BY_ITEM_EXPORT = `${CREDITS_BASE_URL}/v1/credits/usage/by_item/export`;
export const GET_CREDIT_USAGE_BY_USER = `${CREDITS_BASE_URL}/v1/credits/usage/by_user`;
export const GET_CREDIT_USAGE_BY_USER_EXPORT = `${CREDITS_BASE_URL}/v1/credits/usage/by_user/export`;
export const GET_RECHARGE_HISTORY = `${CREDITS_BASE_URL}/v1/recharge_requests/history`;
export const GET_RECHARGE_HISTORY_DETAIL = (requestId: string) =>
  `${CREDITS_BASE_URL}/v1/recharge_requests/history/${requestId}`;
export const GET_RECHARGE_HISTORY_EXPORT = `${CREDITS_BASE_URL}/v1/recharge_requests/export`;

export const EXPORT_BY_USER_ITEM_CREDIT_HISTORY = `${CREDITS_BASE_URL}/v1/credits/usage/by_user_item/export`;

export const update_AUTOQUALIFICATION_ICP_FLAG = (key: number, flag: boolean) =>
  `${REACT_APP_BASE_API_FILTER_URL}/updateContactAutoQualificationFlag?key=${key}&flag=${flag}`;
export const get_SEQUENCES_CMP = (customerId: number, source: string, emailId: string) =>
  `${REACT_APP_BASE_API_FILTER_URL}/cmp/sequences/cusId/${customerId}/source/${source}?email=${emailId}`;
export const get_SEQUENCES_RASPBERRY = (customerId: number, source: string, emailId: string) =>
  `${REACT_APP_BASE_API_FILTER_URL}/cmp/sequences/cusId/${customerId}/source/${source}/v2?email=${emailId}`;
export const get_SEQUENCES_FROM_CMPS = (
  customerId: number,
  source: string,
  emailId: string,
  search: string,
) =>
  `${ADMIN_CONFIG_URL}/cmp/getSequencesFromCmps/cusId/${customerId}/source/${source}?email=${emailId}&search=${search}`;
export const BASE_MAILBOXES_CMP = `${ADMIN_CONFIG_URL}/cmp/mailboxes`;
export const GET_CUSTOMERS_LIST = `${REACT_APP_BASE_API_FILTER_URL}/customer_lists`;
export const GET_COLUMNS_NAME = `${REACT_APP_BASE_API_FILTER_URL}/getColumnNames`;
export const GET_CUSTOM_INSIGHTS_LIST = `${REACT_APP_BASE_API_FILTER_URL}/customInsight/getList`;
export const VALIDATE_CUSTOM_INSIGHT_PROMPT = `${REACT_APP_BASE_API_FILTER_URL}/validatePrompt`;
export const SAVE_CUSTOM_INSIGHTS = `${REACT_APP_BASE_API_FILTER_URL}/customInsight/save`;
export const DELETE_CUSTOM_INSIGHTS = `${REACT_APP_BASE_API_FILTER_URL}/customInsight/delete`;
export const PREVIEW_CUSTOM_INSIGHT_MESSAGE = `${REACT_APP_BASE_API_FILTER_URL}/previewMessage`;
export const GET_CUSTOM_INSIGHTS_SUGGESTION = `${REACT_APP_BASE_API_FILTER_URL}/getSuggestion`;
export const GET_ICP_LIST = `${REACT_APP_BASE_API_FILTER_URL}/v2/personaList`;
export const SAVE_ICP_LIST = `${REACT_APP_BASE_API_FILTER_URL}/v2/savePersonaList`;
export const get_CUSTOMER_LIST_BY_ID = (listId: string) =>
  `${REACT_APP_BASE_API_FILTER_URL}/customer_lists/${listId}`;
export const get_LIST_RECORDS = (listId: string) =>
  `${REACT_APP_BASE_API_FILTER_URL}/customer_lists/${listId}/contacts`;
export const REFRESH_TOKEN = `${BASE_API_URL}/refresh-token`;
export const GET_CUSTOMER_RULES = (tenantId: string | number) =>
  `${QUALIFY_URL}/api/v2/rule-configs?tenantId=${tenantId}`;
export const GET_ALLOWED_DOMAINS = `${WEB_TRACK_URL}/v1/customers/allowed_domains`;
export const TRAFFIC_RESTRICTIONS_BASE = `${WEB_TRACK_URL}/v1/customers/restrictions`;
export const traffic_restriction_by_id = (id: string) =>
  `${WEB_TRACK_URL}/v1/customers/restrictions/${id}`;
export const traffic_restriction_activate = (id: string) =>
  `${WEB_TRACK_URL}/v1/customers/restrictions/${id}/activate`;
export const traffic_restriction_deactivate = (id: string) =>
  `${WEB_TRACK_URL}/v1/customers/restrictions/${id}/deactivate`;
export const GET_CONTACTS_VISITED = `${REACT_APP_BASE_API_FILTER_URL}/website/contacts`;
export const QUALIFY_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/qualify-contact`;
export const GET_CMP_NAME = `${BASE_API_URL}/get-cmp-name`;
export const GET_ACCESS_TOKEN = `${BASE_API_URL}/get-cmp-token`;
export const REGISTER_CMP_USER = `${BASE_API_URL}/register-user-cmp`;
export const AI_SIGNAL_ATTRIBUTES = `${REACT_APP_BASE_API_FILTER_URL}/technologies/category`;
export const AI_SIGNAL_CONFIGURE_ENRICH = `${REACT_APP_BASE_API_FILTER_URL}/technologies/configureAndEnrich`;
export const GET_AI_SIGNAL = `${REACT_APP_BASE_API_FILTER_URL}/technologies`;
export const DELETE_AI_SIGNAL = `${REACT_APP_BASE_API_FILTER_URL}/technologies/remove`;
export const ENRICH_AI_SIGNAL = `${REACT_APP_BASE_API_FILTER_URL}/technologies/enrich`;
// Tech stack signal — category-based lazy fetch endpoints
export const GET_TECH_CATEGORY_LIST = `${REACT_APP_BASE_API_FILTER_URL}/technologies/category/list`;
export const GET_TECH_BY_CATEGORY = `${REACT_APP_BASE_API_FILTER_URL}/technologies/list`;
export const GET_TECH_POLLING = `${REACT_APP_BASE_API_FILTER_URL}/technologies/polling`;
export const GET_TECH_CONFIGURED = `${REACT_APP_BASE_API_FILTER_URL}/technologies/configure`;
export const SEND_MAIL_AI_SIGNAL = `${REACT_APP_BASE_API_FILTER_URL}/technologies/sendMailTech`;
export const UPDATE_TENANT_VIEW = `${REACT_APP_BASE_API_FILTER_URL}/update/tenant/view`;
export const REMOVE_CUSTOMER_INTENT_TOPICS = `${REACT_APP_BASE_API_FILTER_URL}/remove/customer/intents`;
export const PROVIDE_ACCESS_TO_CMP = `${BASE_API_URL}/register-user-cmp-manualy`;
export const REMOVE_CMP_ACCESS = `${BASE_API_URL}/cmp-revoke-user-access`;
export const PROVIDE_ACCESS_TO_STRAWBERRY = `${ADMIN_CONFIG_URL}/oauth/provide-access-to-strawberry`;
export const REVOKE_ACCESS_TO_STRAWBERRY = `${ADMIN_CONFIG_URL}/oauth/revoke-access-to-strawberry`;
export const TRANSFER_CMP_OWNER = `${ADMIN_CONFIG_URL}/cmp/transfer-cmp-owner`;
export const CHANGE_CMP_PASSWORD = `${BASE_API_URL}/cmp/change-cmp-password`;
export const CONTACT_REVEAL = `${REACT_APP_BASE_API_FILTER_URL}/contact/revealed`;
export const ACCOUNT_REVEAL = `${REACT_APP_BASE_API_FILTER_URL}/account/revealed`;
export const UPDATE_AUTO_QUALIFICATION_FLAG = `${REACT_APP_BASE_API_FILTER_URL}/updateContactAutoQualificationFlag`;
export const GET_CUSTOMER_DATA = `${REACT_APP_BASE_API_FILTER_URL}/aisignal/getCustomerData`;
export const UPDATE_CUSTOM_AI_SIGNAL = `${REACT_APP_BASE_API_FILTER_URL}/aisignal/update`;
export const ADD_CUSTOM_AI_SIGNAL = `${REACT_APP_BASE_API_FILTER_URL}/aisignal/add`;
export const GET_BULK_IMPORT_LOGS = `${REACT_APP_BASE_API_FILTER_URL}/logs/getLogs`;
export const GET_IMPORTED_FILE_NAMES = `${REACT_APP_BASE_API_FILTER_URL}/logs/searchText`;
export const GET_IMPORT_LOGS_BASED_FILENAME = `${REACT_APP_BASE_API_FILTER_URL}/logs/getLogsByFileName`;
export const GET_CALL_RECORDING = `${ADMIN_CONFIG_URL}/cmp/fetch-call-recording`;
export const GET_JOB_SKILLS = `${REACT_APP_BASE_API_FILTER_URL}/jobOpening/getJobSkills`;
export const GET_JOB_CATEGORIES = `${REACT_APP_BASE_API_FILTER_URL}/jobOpening/getJobCategories`;
export const GET_JOB_OPENING_SIGNAL = `${REACT_APP_BASE_API_FILTER_URL}/jobOpening/getJobOpenings`;
export const SAVE_JOB_OPENING_SIGNAL = `${REACT_APP_BASE_API_FILTER_URL}/jobOpening/save`;
export const UPDATE_JOB_OPENING_SIGNAL = `${REACT_APP_BASE_API_FILTER_URL}/jobOpening/update`;
export const DELETE_JOB_OPENING_SIGNAL = `${REACT_APP_BASE_API_FILTER_URL}/jobOpening/deleteJobOpenings`;
export const ENRICH_JOB_OPENING_SIGNAL = `${REACT_APP_BASE_API_FILTER_URL}/jobOpening/enrich`;
export const POLLING_JOB_OPENING_SIGNAL = `${REACT_APP_BASE_API_FILTER_URL}/jobOpening/enrichPoll`;
export const GET_JOB_OPENING_DATA_FOR_ACCOUNT = `${REACT_APP_BASE_API_FILTER_URL}/jobOpening/jobOpeningForAnAccount`;
export const TERMINATE_JOB_OPENING_SIGNAL = `${REACT_APP_BASE_API_FILTER_URL}/jobOpening/terminateJobOpenings`;
export const GET_CONTACT_ENRICHED_DATA = `${REACT_APP_BASE_API_FILTER_URL}/v1/contacts/enrichPoll`;
export const ENRICH_FIELDS_TAL = `${REACT_APP_BASE_API_FILTER_URL}/v1/contacts/enrich`;
export const GET_INPROGRESS_ENRICH_JOBS = `${REACT_APP_BASE_API_FILTER_URL}/v1/waterfall/inprogress/jobs`;
export const SET_ENRICHMENT_SOURCES = `${MDQS_BASEURL}/v1/contacts/field_enrichment/config`;
export const CONVERT_TO_PRIMARY = `${REACT_APP_BASE_API_FILTER_URL}/v1/contacts/`;
export const GET_USER_PREFERENCES = `${REACT_APP_BASE_API_FILTER_URL}/user/preferences`;
export const SAVED_FILTER_TP = `${REACT_APP_BASE_API_FILTER_URL}/savedFilter/`;
export const GET_ACCOUNT_REGIONS_BASED_ON_DOMAINS = `${REACT_APP_BASE_API_FILTER_URL}/multiChild/getRegion`;
export const GET_MULTI_CHILD_ACCOUNTS_INFO = `${REACT_APP_BASE_API_FILTER_URL}/multiChild/getAccountInfo`;
export const GET_MULTI_CHILD_CONTACTS_INFO = `${REACT_APP_BASE_API_FILTER_URL}/multiChild/getContactInfo`;
export const UPDATE_MULTI_CHILD_REGION = `${REACT_APP_BASE_API_FILTER_URL}/multiChild/updateContactRegion`;

export const HIGHLIGHTING_WIIFT = 'https://qaml.sprouts.ai/high/highlight/';
export const GET_ALL_CHAMPIONS_DATA = `${REACT_APP_BASE_API_FILTER_URL}/champion/getChampionData`;
export const GET_CHAMPIONS_WITH_JOB_CHANGE_DATA = `${REACT_APP_BASE_API_FILTER_URL}/champion/getChampionDataWithJobChange`;
export const GET_CHAMPIONS_HEADERS_LIST = `${REACT_APP_BASE_API_FILTER_URL}/champion/getHeaderList`;
export const UPLOAD_CHAMPIONS_DATA = `${REACT_APP_BASE_API_FILTER_URL}/champion/uploadFile`;
export const REMOVE_CONTACTS_FROM_CHAMPIONS = `${REACT_APP_BASE_API_FILTER_URL}/champion/delete`;
export const MOVE_TO_TAL_FROM_CHAMPIONS = `${REACT_APP_BASE_API_FILTER_URL}/champion/moveToTal`;

export const HPM_CONFIG_GET_PAINPOINTS = `${HPM_CONFIG_BASE_URL}/wiift/v1/getList`;
export const HPM_CONFIG_DELETE_PAINPOINT = `${HPM_CONFIG_BASE_URL}/wiift/v1/delete`;

export const HPM_CONFIG_GET_INTROS = `${HPM_CONFIG_BASE_URL}/insightConfig/v1/getList`;
export const HPM_CONFIG_INITIAL_INTRO = `${HPM_CONFIG_BASE_URL}/insightConfig/config/getList`;

export const HPM_CONFIG_SAVE_PERSONA = `${HPM_CONFIG_BASE_URL}/insightConfig/wiift/save`;
export const HPM_CONFIG_CLONE = `${HPM_CONFIG_BASE_URL}/insightConfig/clone/save`;

export const HPM_CONFIG_SAVE_NEW_HCP_PERSONA = `${HPM_CONFIG_BASE_URL}/hpmConfigPersona/save`;
export const HPM_CONFIG_GET_HCP_INTROS = `${HPM_CONFIG_BASE_URL}/hpmConfigPersona/getList`;
export const HPM_CONFIG_HCP_LIST = `${HPM_CONFIG_BASE_URL}/hpmConfigPersona/getList`;

export const REFINE_QUERY = `${ML_BASE_URL}/refine-signals-query/v1`;
export const GET_AI_SIGNAL_DATA = `${ML_BASE_URL}/customnewssearch/retrieve`;
export const GET_AI_SIGNAL_PREVIEW_DATA = `${ML_BASE_URL}/customaisignals/generate-signal-response`;
export const AI_SIGNAL_REFRESH_TOOGLE = `${REACT_APP_BASE_API_FILTER_URL}/v1/aisignal/refresh-filters`;

export const ADD_NEW_CUSTOM_AI_SIGNAL = `${REACT_APP_BASE_API_FILTER_URL}/v1/aisignal/save`;
export const UPDATE_CUSTOM_AI_SIGNAL_NEW = `${REACT_APP_BASE_API_FILTER_URL}/v1/aisignal/update`;
export const GET_AI_NEWS_COLUMN_DATA = `${REACT_APP_BASE_API_FILTER_URL}/v1/aisignal/getCustomerData`;
export const GET_AI_NEWS_ACCOUNT_STATUS = `${REACT_APP_BASE_API_FILTER_URL}/v1/aisignal/getAiNewsAccountStatus`;
export const GET_PRECONFIGURED_AI_SIGNAL = `${REACT_APP_BASE_API_FILTER_URL}/aisignal/getPreconfiguredAiSignal`;
export const TERMINATE_AI_SIGNAL = `${REACT_APP_BASE_API_FILTER_URL}/aisignal/terminate`;
export const GET_GEO_LOCATIONS = `${REACT_APP_BASE_API_FILTER_URL}/aisignal/get-geo-locations?pageSize=10`;
export const RUN_COLUMN_CUSTOM_AI_SIGNAL_NEW = `${REACT_APP_BASE_API_FILTER_URL}/v1/aisignal/enrich-by-column`;
export const RUN_CELL_CUSTOM_AI_SIGNAL_NEW = `${REACT_APP_BASE_API_FILTER_URL}/v1/aisignal/enrich-by-cell`;
export const SIGNAL_TERMINATE = `${REACT_APP_BASE_API_FILTER_URL}/v1/aisignal/update-pending-signals`;
export const ASK_AI_FORCE_TERMINATE = `${REACT_APP_BASE_API_FILTER_URL}/ask-ai/force-terminate`;
export const GET_AI_NEWS_SMART_SEARCH = `${ML_BASE_URL}/smart-search-service/api/v1/search-preconfigured-ai-signal`;
export const REGISTER_PLG_USER = `${BASE_API_URL}/plg/register`;
export const VERIFY_MAGIC_LINK = `${BASE_API_URL}/verify-link`;
export const ACTIVATE_LINK = `${BASE_API_URL}/verify-plg-link`;
export const GET_MAGIC_LINK = `${BASE_API_URL}/magicLink`;
export const GET_INTENT_TOPICS_WITH_CATEGORIES = `${REACT_APP_BASE_API_FILTER_URL}/topicApi/topic-category-mappings`;
export const GET_CONFIGURED_INTENT_TOPICS_WITH_CATEGORIES = `${REACT_APP_BASE_API_FILTER_URL}/topicApi/topics-associated-with-customer`;
export const GET_NOT_CONFIGURED_INTENT_TOPICS_WITH_CATEGORIES = `${REACT_APP_BASE_API_FILTER_URL}/topicApi/topics-not-associated-with-customer`;
export const TOPIC_CATEGORY_MAPPINGS_SEARCH = `${REACT_APP_BASE_API_FILTER_URL}/topicApi/topic-category-mappings-search`;
export const TOPIC_LIST_BY_CATEGORY = `${REACT_APP_BASE_API_FILTER_URL}/topicApi/topic-list-by-category`;
export const GET_AI_GENERATED_INTENT_TOPICS = `${REACT_APP_BASE_API_FILTER_URL}/topicApi/ai-generated-intent-topics`;
export const CONFIGURE_AI_INTENT_TOPICS = `${REACT_APP_BASE_API_FILTER_URL}/topicApi/configure-ai-intent-topics`;
export const GET_ALL_CHAMPIONS_IDS = `${REACT_APP_BASE_API_FILTER_URL}/champion/getAll-champion-ids`;
export const delete_user_invitation = (id: string | number) => `${BASE_API_URL}/delete/${id}`;
export const GET_ONBOARDING_PROGRESS = `${BASE_API_URL}/getProgressData`;
export const UPDATE_ONBOARDING_PROGRESS = `${BASE_API_URL}/setProgressData`;
export const SOURCE_TAL_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/auto/contact-tal`;
export const AUTO_FETCH_ICP_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/auto/auto-account-contact`;
export const SOURCE_WAL_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/auto/contact-web-visit`;
export const DBS_BULK_QUALIFY = `${MDQS_BASEURL}/v1/target_profiles`;
export const GET_ROLE_CONFIG = `${BASE_API_URL}/permission/config`;
export const GET_ROLE_DETAILS = `${BASE_API_URL}/permission/getRoleDetails`;
export const CREATE_ROLE = `${BASE_API_URL}/permission/addRole`;
export const UPDATE_ROLE = `${BASE_API_URL}/permission/updateRole`;
export const GET_ALL_ROLES = `${BASE_API_URL}/permission/getRole`;
export const ASSIGN_ROLE_TO_USER = `${BASE_API_URL}/permission/assignRole`;
export const FETCH_PERMISSIONS = `${BASE_API_URL}/permission/getPermissionByUser`;
export const CREATE_NEW_SEQUENCE = `${REACT_APP_BASE_API_FILTER_URL}/cmp/create`;

export const GET_WEBSITE_AGENT_CONFIG_DETAILS = `${REACT_APP_BASE_API_FILTER_URL}/website-agent/get-website-agent`;
export const SAVE_WEBSITE_AGENT_GENERAL = `${REACT_APP_BASE_API_FILTER_URL}/website-agent/save-general`;
export const SAVE_WEBSITE_AGENT_SIGNALS = `${REACT_APP_BASE_API_FILTER_URL}/website-agent/save-sprouts-signal`;
export const SAVE_WEBSITE_AGENT_BASIC_SETUP = `${REACT_APP_BASE_API_FILTER_URL}/website-agent/save-basic`;
export const GET_WEBSITE_AGENT_S3_URL = `${REACT_APP_BASE_API_FILTER_URL}/website-agent/upload-knowledge-base-file`;
export const SAVE_WEBSITE_AGENT_KNOWLEDGE_BASE = `${REACT_APP_BASE_API_FILTER_URL}/website-agent/save-knowledge-base`;
export const DELETE_WEBSITE_AGENT_KNOWLEDGE_BASE = `${REACT_APP_BASE_API_FILTER_URL}/website-agent/delete-knowledge-base`;
export const SAVE_WEBSITE_AGENT_CONVERSATION_SETUP = `${REACT_APP_BASE_API_FILTER_URL}/website-agent/save-conversation`;
export const GET_CHAMPIONS_MOVED_TO_TAL = `${REACT_APP_BASE_API_FILTER_URL}/champion/getChampionDataWithMoveToTal`;
export const MAKE_ADMIN_DEFAULT_VIEW_FOR_ALL_USERS = `${REACT_APP_BASE_API_FILTER_URL}/makeAdminDefaultViewForAllUsers`;
export const UPDATE_EMAIL_PHONE_AUTO_ENRICH_FLAG = `${REACT_APP_BASE_API_FILTER_URL}/auto/update-auto-enrich-flag`;
export const SPROUTS_AGENT_BASE_URL = `${SPROUTS_AGENT_BASE_ENDPOINT}`;
export const DEEPGRAM_TTS_URL = 'https://api.deepgram.com/v1/speak?model=aura-asteria-en';
export const DEEPGRAM_STT_URL =
  'wss://api.deepgram.com/v1/listen?model=nova-3&numerals=true&interim_results=true&punctuate=true&&diarize=true&utterance_end=true';
export const GET_ENRICH_EMAIL_PHONE_NUMBER_FLAGS = `${REACT_APP_BASE_API_FILTER_URL}/auto/get-auto-enrich-flag`;
export const FETCH_GLOBAL_CREDITS = `${MDQS_BASEURL}/v1/enrichments/source_wise`;
export const fetchCustomerWaterfallCredits = (clientId?: string) =>
  `${MDQS_BASEURL}/v1/enrichments/${clientId}/source_wise`;
export const FETCH_GLOBAL_BULK_CREDITS = `${MDQS_BASEURL}/v1/enrichments/bulk/source_wise`;
export const fetchCustomerGlobalBulkCredits = (clientId: string) =>
  `${MDQS_BASEURL}/v1/enrichments/bulk/${clientId}/source_wise`;
export const fetchAllWaterfallCredits = `${MDQS_BASEURL}/v1/enrichments/source_wise`;
export const RIME_TTS_URL = 'https://users.rime.ai/v1/rime-tts';
export const GET_USERS_AUDIT_LOGS = `${BASE_API_URL}/get-user-activity-logs`;
export const RULE_DEFINITION = `${RULE_DEFINITION_URL}/api/playbooks`;
export const RULE_DEFINITION_TEMPLATES = `${RULE_DEFINITION_URL}/api/templates`;
export const RULE_DEFINITION_V1 = `${RULE_DEFINITION_URL_V1}/api/playbooks`;
export const GET_PLAYBOOK_BY_ID = (id: string) => `${RULE_DEFINITION_URL_V1}/api/playbooks/${id}`;
export const UPDATE_PLAYBOOK_STATUS = (id: string) =>
  `${RULE_DEFINITION_URL_V1}/api/playbooks/${id}/status`;
export const UPDATE_PLAYBOOK = (id: string) => `${RULE_DEFINITION_URL_V1}/api/playbooks/${id}`;
export const SAVE_PLAYBOOK = `${RULE_DEFINITION_URL_V1}/api/playbooks/`;
export const CLONE_PLAYBOOK_WORKFLOW = (id: string) => `${RULE_DEFINITION_URL_V1}/api/playbooks/${id}/clone`;
export const DELETE_PLAYBOOK = (id: string) => `${RULE_DEFINITION_URL_V1}/api/playbooks/${id}`;
export const RENAME_PLAYBOOK = (id: string) => `${RULE_DEFINITION_URL_V1}/api/playbooks/${id}`;
export const RULE_DEFINITION_TEMPLATES_V1 = `${RULE_DEFINITION_URL_V1}/api/templates`;

// JSON Workflow Creation Endpoints
export const CREATE_PLAYBOOK_FROM_JSON = `${RULE_DEFINITION_URL_V1}/api/playbooks/from-json`;
export const VALIDATE_PLAYBOOK_JSON = `${RULE_DEFINITION_URL_V1}/api/playbooks/validate-json`;

// Dynamic field config for playbook nodes
export const GET_PLAYBOOK_COLUMN_LIST = (entity: string) =>
  `${REACT_APP_BASE_API_FILTER_URL}/playbooks/get-column-list?entity=${entity}`;
export const GET_PLAYBOOK_NODE_FIELD_CONFIG = (nodeType: string) =>
  `${RULE_DEFINITION_URL_V1}/api/playbooks/node-field-config?nodeType=${nodeType}`;
export const SAVE_PLAYBOOK_NODE_FIELD_CONFIG = `${RULE_DEFINITION_URL_V1}/api/playbooks/node-field-config`;

export const GET_ACCOUNT_DETAILS_BY_ID = `${REACT_APP_BASE_API_FILTER_URL}/account/getAccount`;
export const GET_ACCOUNT_ACTIVITY = `${REACT_APP_BASE_API_FILTER_URL}/account/getAccountActivity`;
export const GET_ACCOUNT_ACTIVITY_COUNTS = `${REACT_APP_BASE_API_FILTER_URL}/account/getAccountActivityCount`;
export const ADD_ACCOUNTS_NOTES = `${REACT_APP_BASE_API_FILTER_URL}/account/addUserAccountNote`;
export const GET_ACCOUNT_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/account/getContacts`;
export const GET_ACCOUNT_CONTACTS_IDS = `${REACT_APP_BASE_API_FILTER_URL}/account/getContactId`;
export const UPDATE_ACCOUNTS_NOTES = `${REACT_APP_BASE_API_FILTER_URL}/account/updateNote`;
export const ACCOUNT_NOTES_LIST = `${REACT_APP_BASE_API_FILTER_URL}/account/getNotes`;
export const GET_ACCOUNT_DETAILS_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/account/getContacts`;
export const GET_ACCOUNT_TECHSTACK = `${REACT_APP_BASE_API_FILTER_URL}/account/getTechStack`;
export const GET_ACCOUNT_INTENT_TOPICS = `${REACT_APP_BASE_API_FILTER_URL}/account/getTopic`;
export const GET_ACCOUNT_CHAMPIONS_DATA = `${REACT_APP_BASE_API_FILTER_URL}/account/getChampionData`;
export const GET_ACCOUNT_AI_SIGNALS = `${REACT_APP_BASE_API_FILTER_URL}/v1/aisignal/get-ai-signals-for-account`;
export const GET_ACCOUNT_INTELLIGENCE = `${REACT_APP_BASE_API_FILTER_URL}/sprouts/intelligence/account-info`;
export const ENRICH_ALL_INSIGHTS = `${REACT_APP_BASE_API_FILTER_URL}/sprouts/intelligence/enrich-all-insights`;
export const GET_COMPETITOR_INSIGHTS = `${REACT_APP_BASE_API_FILTER_URL}/sprouts/intelligence/get-competitor-insights`;
export const GET_WORKFORCE_INSIGHTS = `${REACT_APP_BASE_API_FILTER_URL}/sprouts/intelligence/get-workforce-insights`;
export const GET_TECHNOGRAPHIC_INSIGHTS = `${REACT_APP_BASE_API_FILTER_URL}/sprouts/intelligence/get-technographic-insights`;
export const GET_CONTACT_FILTER = `${REACT_APP_BASE_API_FILTER_URL}/sprouts/intelligence/get-contact-filter`;
export const GET_OPPORTUNITY_INSIGHTS = `${REACT_APP_BASE_API_FILTER_URL}/sprouts/intelligence/get-opportunity-insights`;
export const GET_INTELLIGENCE_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/sprouts/intelligence/get-contacts`;
export const GET_ORG_STRUCTURE = `${REACT_APP_BASE_API_FILTER_URL}/sprouts/intelligence/get-org-structure`;
export const ENRICH_EMAIL_PHONE = `${REACT_APP_BASE_API_FILTER_URL}/sprouts/intelligence/enrich-email-phone`;
export const GET_ZOOM_REDIRECT_URL = `${ADMIN_CONFIG_URL}/cmp/fetch-zoom-meeting`;
export const POLL_CUSTOM_FIELDS_INTEGRATED_DATA = `${REACT_APP_BASE_API_FILTER_URL}/polling/integrated/data`;
export const FETCH_MDQS_JOB_TITLE = `${MDQS_BASEURL}/v1/filters/tags/title?page=1&page_size=25&search_text=`;
export const FETCH_MDQS_PERSONA_LOCATION = `${MDQS_BASEURL}/v1/filters/tags/person_location?page=1&page_size=25&search_text=`;
export const GET_REALTIME_ICP_CONFIG = `${REACT_APP_BASE_API_FILTER_URL}/account/icp/config`;
export const SAVE_REALTIME_ICP_CONFIG = `${REACT_APP_BASE_API_FILTER_URL}/account/icp/config/save`;
export const GET_ICP_SETUP_STATUS = `${REACT_APP_BASE_API_FILTER_URL}/account/icp/setup-status`;
export const DELETE_REALTIME_ICP = `${REACT_APP_BASE_API_FILTER_URL}/account/icp/config/reset`;
export const CUSTOM_ICP_POLLING = `${REACT_APP_BASE_API_FILTER_URL}/custom-icp/polling`;
export const RECALCULATE_STALE_ICP_SCORES = `${REACT_APP_BASE_API_FILTER_URL}/icp-backup/recalculate-stale-icp-scores`;
export const CREATE_ACCOUNT_LIST = `${REACT_APP_BASE_API_FILTER_URL}/accountList/create`;
export const REMOVE_ACCOUNT_FROM_ACCOUNT_LIST = `${REACT_APP_BASE_API_FILTER_URL}/accountList/removeAccountFromList`;
export const GET_ACCOUNTS_DATA_BASED_ON_ID = `${REACT_APP_BASE_API_FILTER_URL}/accountList/getAccountByListId`;
export const REMOVE_ACCOUNTS_FROM_ACCOUNT_LIST = `${REACT_APP_BASE_API_FILTER_URL}/accountList/removeAccountFromList`;
export const GET_ACCOUNT_LISTS_BASED_ON_ID = `${REACT_APP_BASE_API_FILTER_URL}/accountList/getListNameBelongsToAccount`;
export const GET_ALL_ACCOUNTS_IDS_LIST_PAGE = `${REACT_APP_BASE_API_FILTER_URL}/accountList`;
export const EXPORT_VIEW_LIST_PAGE_DATA = `${REACT_APP_BASE_API_FILTER_URL}/exportTargetProfilesForAccounts`;
export const BULK_EMAIL_VALIDATION = `${REACT_APP_BASE_API_FILTER_URL}/v1/email-validation`;
export const EMAIL_VALIDATION_POLL = `${REACT_APP_BASE_API_FILTER_URL}/v1/email-validation/poll-validation`;
export const SOURCE_CONTACT_GET_TAL_ACCOUNTS = `${REACT_APP_BASE_API_FILTER_URL}/getTalAccountDetails`;
export const GET_CONTACT_DETAILS_BY_ACCOUNT = `${REACT_APP_BASE_API_FILTER_URL}/contact-details/account`;
export const GET_CONTACT_DETAILS_BY_ID = `${REACT_APP_BASE_API_FILTER_URL}/contact-details`;
export const GET_CONTACT_DETAILS_NOTES = `${REACT_APP_BASE_API_FILTER_URL}/contact-details/notes`;
export const ADD_UPDATE_CONTACT_DETAILS_NOTES = `${REACT_APP_BASE_API_FILTER_URL}/contact-details/add-update-notes`;
export const GET_CONTACT_DETAILS_SIMILAR_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/contact-details/similar-contact`;
export const GET_CONTACT_ACTIVITY = `${REACT_APP_BASE_API_FILTER_URL}/contact-details/activity`;
export const GET_CONTACT_ACTIVITY_COUNTS = `${REACT_APP_BASE_API_FILTER_URL}/contact-details/activity-count`;
export const GET_CONTACT_ES_DETAILS = `${REACT_APP_BASE_API_FILTER_URL}/contact-details/contact`;
export const GET_OPPORTUNITIES = `${REACT_APP_BASE_API_FILTER_URL}/contact-details/opportunities`;
export const GET_ACCOUNT_LIST_OPTIONS = `${REACT_APP_BASE_API_FILTER_URL}/filter/account/`;
export const get_CONTACTS_UNIQUE_PAGE_VISITS_DATES = (contactId: string, userTimezone: string) =>
  `${WEB_TRACK_URL}/v1/iplookups/contacts/${contactId}/visitDates?time_zone=${userTimezone}`;
export const get_CONTACTS_UNIQUE_IP_LOCATIONS = (
  contactId: string,
  date: string,
  userTimezone: string,
) =>
  `${WEB_TRACK_URL}/v1/iplookups/contacts/${contactId}/visitDates/${date}?time_zone=${userTimezone}`;
export const get_CONTACTS_PAGE_VISITS_FOR_CONTACT_ID = (
  contactId: string,
  date: string,
  userTimezone: string,
) =>
  `${WEB_TRACK_URL}/v1/iplookups/contacts/${contactId}/visitDates/${date}/ipLocations?time_zone=${userTimezone}`;
export const TARGET_PROFILES_STATUS = `${MDQS_BASEURL}/v1/target_profiles/status`;
export const MDQS_JOBS_STATUS = `${MDQS_BASEURL}/v1/target_profiles/job_status`;
export const EXPORT_WEBSITE_CONTACT_REVEAL = `${REACT_APP_BASE_API_FILTER_URL}/website/revealed/contact/export`;
export const GET_CONTACTS_EXCLUSION_LIST = `${REACT_APP_BASE_API_FILTER_URL}/v1/contact-exclusion/get-exclusion-list`;
export const ADD_CONTACTS_EXCLUSION_LIST = `${REACT_APP_BASE_API_FILTER_URL}/v1/contact-exclusion/add-record`;
export const GET_CONTACTS_EXCLUSION_HEADERS_LIST = `${REACT_APP_BASE_API_FILTER_URL}/v1/contact-exclusion/get-header-list`;
export const CONTACT_EXCLUSION_UPLOAD_FILE = `${REACT_APP_BASE_API_FILTER_URL}/v1/contact-exclusion/upload-file`;
export const EXCLUDE_CONTACTS_BASED_ON_ID = `${REACT_APP_BASE_API_FILTER_URL}/v1/contact-exclusion/add-by-id`;
export const UPDATE_EXCLUSION_CONTACT_RECORD = `${REACT_APP_BASE_API_FILTER_URL}/v1/contact-exclusion/update-record`;
export const DELETE_EXCLUSION_CONTACT_RECORD = `${REACT_APP_BASE_API_FILTER_URL}/v1/contact-exclusion/delete`;
export const GET_EMP_BY_DEPT_VALUES = `${MDQS_BASEURL}/v1/filters/tags/department_head?page=1&page_size=100&search_text=`;
export const MDQS_PERSON_LOCATION_FILTER = `${MDQS_BASEURL}/v1/filters/tags/person_location`;
export const ARCHIVE_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/delete/inactive-contact`;
export const ARCHIVE_ACCOUNTS = `${REACT_APP_BASE_API_FILTER_URL}/delete/inactive-account`;
export const UNARCHIVE_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/delete/active-contact`;
export const UNARCHIVE_ACCOUNTS = `${REACT_APP_BASE_API_FILTER_URL}/delete/active-account`;
export const ARCHIVED_ACCOUNTS = `${REACT_APP_BASE_API_FILTER_URL}/delete/get-accounts`;
export const ARCHIVED_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/delete/get-contacts`;
export const get_ARP_ACCOUNTs_COMPANIES_FILTER_API = (customerId: string) =>
  `${REACT_APP_BASE_API_FILTER_URL}/filter/account/delete/${customerId}/getOrg?page_size=25&searchText=`;
export const get_ARP_CONTACTs_COMPANIES_FILTER_API = (customerId: string) =>
  `${REACT_APP_BASE_API_FILTER_URL}/filter/contact/delete/${customerId}/getOrg?page_size=25&searchText=`;
export const get_ARP_ACCOUNT_ARCHIVED_BY_FILTER_API = (customerId: string) =>
  `${REACT_APP_BASE_API_FILTER_URL}/filter/account/delete/${customerId}/getOwner?page_size=25&searchText=`;
export const get_ARP_CONTACT_ARCHIVED_BY_FILTER_API = (customerId: string) =>
  `${REACT_APP_BASE_API_FILTER_URL}/filter/contact/delete/${customerId}/getOwner?page_size=25&searchText=`;
export const ENRICHMENT_LOGS_TABLE_API = `${REACT_APP_BASE_API_FILTER_URL}/v1/contacts/enrichment/logs`;
export const ENRICHMENT_LOGS_EXPORT_API = `${REACT_APP_BASE_API_FILTER_URL}/v1/contacts/enrichment/logs/export`;
export const ENRICHMENT_LOGS_USERS_FILTER_API = `${REACT_APP_BASE_API_FILTER_URL}/v1/contacts/enrichment/logs/user_filter?key=`;
export const ENRICHMENT_LOGS_FILE_NAME_FILTER_API = `${REACT_APP_BASE_API_FILTER_URL}/v1/contacts/enrichment/logs/file_name_filter?key=`;
export const get_ALL_LISTS_IN_LIST_DETAILS_PAGE = (id: string) =>
  `${REACT_APP_BASE_API_FILTER_URL}/customer_lists/${id}`;
export const GET_SELECTIVE_ICP_FILTERS = `${REACT_APP_BASE_API_FILTER_URL}/customer-icp/selective-fetch`;
export const GET_ICP_INTENT_TOPICS = `${REACT_APP_BASE_API_FILTER_URL}/filter/account`;

// Orchestrator Service Endpoints
export const ORCHESTRATOR_EXECUTE = `${RULE_DEFINITION_URL_V1}/api/orchestrator/execute`;
export const ORCHESTRATOR_EXECUTION_STATUS = (executionId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/orchestrator/execution/${executionId}/status`;
export const ORCHESTRATOR_EXECUTION_STOP = (executionId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/orchestrator/execution/${executionId}/stop`;
export const ORCHESTRATOR_EXECUTION_HISTORY = (workflowId: string, limit: number = 10) =>
  `${RULE_DEFINITION_URL_V1}/api/orchestrator/workflow/${workflowId}/history?limit=${limit}`;
export const ORCHESTRATOR_VALIDATE = `${RULE_DEFINITION_URL_V1}/api/orchestrator/validate`;

// Workflow Credentials Endpoints - Using database system with proper user creation
export const WORKFLOW_CREDENTIALS = `${RULE_DEFINITION_URL_V1}/api/credential-management`;
export const WORKFLOW_CREDENTIALS_BY_TYPE = (type: string) =>
  `${RULE_DEFINITION_URL_V1}/api/credential-management?type=${type}`;
export const WORKFLOW_CREDENTIAL_BY_ID = (id: string) =>
  `${RULE_DEFINITION_URL_V1}/api/credential-management/${id}`;
export const WORKFLOW_CREDENTIAL_TEST = (id: string) =>
  `${RULE_DEFINITION_URL_V1}/api/credential-management/${id}/test`;

export const GET_SLACK_CHANNELS = `${RULE_DEFINITION_URL_V1}/api/integrations/slack/channels`;
// OAuth endpoints still use old system for token exchange
export const WORKFLOW_CREDENTIAL_GOOGLE_OAUTH_INITIATE = `${RULE_DEFINITION_URL_V1}/api/credentials/google/oauth/initiate`;
export const WORKFLOW_CREDENTIAL_GOOGLE_OAUTH_CALLBACK = `${RULE_DEFINITION_URL_V1}/api/credentials/google/oauth/callback`;
export const WORKFLOW_CREDENTIAL_GOOGLE_REFRESH = (credentialId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/credentials/${credentialId}/google/refresh`;

// Slack OAuth endpoints
export const WORKFLOW_CREDENTIAL_SLACK_OAUTH_INITIATE = `${RULE_DEFINITION_URL_V1}/api/credentials/slack/oauth/initiate`;
export const WORKFLOW_CREDENTIAL_SLACK_OAUTH_CALLBACK = `${RULE_DEFINITION_URL_V1}/api/credentials/slack/oauth/callback`;
export const WORKFLOW_CREDENTIAL_SLACK_OAUTH_COMPLETE = `${RULE_DEFINITION_URL_V1}/api/credentials/slack/oauth/complete`;
export const WORKFLOW_CREDENTIAL_SLACK_OAUTH_STATUS = `${RULE_DEFINITION_URL_V1}/api/credentials/slack/oauth/status`;
export const WORKFLOW_CREDENTIAL_SLACK_VALIDATE = `${RULE_DEFINITION_URL_V1}/api/integrations/slack/validate`;
export const WORKFLOW_CREDENTIAL_SLACK_CHANNELS = `${RULE_DEFINITION_URL_V1}/api/integrations/slack/channels`;
export const WORKFLOW_CREDENTIAL_SLACK_WORKSPACES = `${RULE_DEFINITION_URL_V1}/api/integrations/slack/workspaces`;

// Approval endpoints
export const WORKFLOW_APPROVALS = `${RULE_DEFINITION_URL_V1}/api/execution/approval`;
export const WORKFLOW_APPROVAL_BY_TOKEN = (token: string) =>
  `${RULE_DEFINITION_URL_V1}/api/execution/approval/${token}`;
export const WORKFLOW_APPROVAL_DECIDE = (token: string) =>
  `${RULE_DEFINITION_URL_V1}/api/execution/approval/${token}/decide`;
export const WORKFLOW_APPROVAL_REMIND = (id: string) =>
  `${RULE_DEFINITION_URL_V1}/api/execution/approval/${id}/remind`;

// AI Services endpoints
export const WORKFLOW_OPENAI_EXECUTE = `${RULE_DEFINITION_URL_V1}/api/ai/openai/execute`;
export const WORKFLOW_OPENAI_VALIDATE = `${RULE_DEFINITION_URL_V1}/api/ai/openai/validate`;
export const WORKFLOW_OPENAI_MODELS = `${RULE_DEFINITION_URL_V1}/api/ai/openai/models`;
export const WORKFLOW_ANTHROPIC_EXECUTE = `${RULE_DEFINITION_URL_V1}/api/ai/anthropic/execute`;
export const WORKFLOW_ANTHROPIC_VALIDATE = `${RULE_DEFINITION_URL_V1}/api/ai/anthropic/validate`;
export const WORKFLOW_ANTHROPIC_MODELS = `${RULE_DEFINITION_URL_V1}/api/ai/anthropic/models`;
export const WORKFLOW_AI_CHAT = `${RULE_DEFINITION_URL_V1}/api/ai/chat`;

// Campaign Management endpoints for Playbook Workflows
export const GET_CUSTOMER_PK = (uniqueId: string) =>
  `${ADMIN_CONFIG_URL}/customer?uniqueId=${uniqueId}`;
export const GET_CAMPAIGN_SEQUENCES = (
  customerId: string,
  source: string,
  emailId: string,
  search?: string,
) =>
  `${REACT_APP_BASE_API_FILTER_URL}/cmp/sequences/cusId/${customerId}/source/${source}?email=${emailId}${
    search ? `&search=${search}` : ''
  }`;

// External API execution endpoints
export const WORKFLOW_EXTERNAL_API_EXECUTE = `${RULE_DEFINITION_URL_V1}/api/platform/execute-node`;
export const WORKFLOW_SOCIAL_SIGNAL_KEYWORD_SUGGESTIONS = `${RULE_DEFINITION_URL_V1}/api/platform/nodes/social-signal/keyword-suggestions`;

// Trigger Service Endpoints
export const WORKFLOW_TRIGGERS_VALIDATE = (triggerId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/triggers/validate/${triggerId}`;
export const WORKFLOW_TRIGGERS_WEBHOOK = `${RULE_DEFINITION_URL_V1}/api/triggers/webhook`;
export const WORKFLOW_TRIGGERS_WEBHOOK_BY_ID = (triggerId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/triggers/webhook/${triggerId}`;
export const WORKFLOW_TRIGGERS_POLLING = `${RULE_DEFINITION_URL_V1}/api/triggers/polling`;
export const WORKFLOW_TRIGGERS_POLLING_BY_ID = (triggerId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/triggers/polling/${triggerId}`;
export const WORKFLOW_TRIGGERS_POLLING_STATE = (triggerId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/triggers/polling/${triggerId}/state`;
export const WORKFLOW_TRIGGERS_SCHEDULE = `${RULE_DEFINITION_URL_V1}/api/triggers/schedule`;
export const WORKFLOW_TRIGGERS_SCHEDULE_BY_ID = (triggerId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/triggers/schedule/${triggerId}`;
export const WORKFLOW_TRIGGERS_EVENTS = `${RULE_DEFINITION_URL_V1}/api/triggers/events`;
export const WORKFLOW_TRIGGERS_HISTORY = (triggerId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/triggers/${triggerId}/history`;
export const WORKFLOW_TRIGGERS_LIST = `${RULE_DEFINITION_URL_V1}/api/triggers`;
export const WORKFLOW_TRIGGERS_BY_TENANT = (tenantId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/triggers/tenant/${tenantId}`;
export const WORKFLOW_TRIGGERS_ACTIVATE = (triggerId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/triggers/${triggerId}/activate`;
export const WORKFLOW_TRIGGERS_DEACTIVATE = (triggerId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/triggers/${triggerId}/deactivate`;
export const WORKFLOW_TRIGGERS_DELETE = (triggerId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/triggers/${triggerId}`;
export const WORKFLOW_TRIGGERS_ROTATE_KEY = (triggerId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/triggers/webhook/${triggerId}/rotate-key`;

// Test Trigger Endpoints
export const WORKFLOW_TRIGGERS_TEST_CRON = `${RULE_DEFINITION_URL_V1}/api/test/triggers/schedule/cron`;
export const WORKFLOW_TRIGGERS_TEST_WEBHOOK = `${RULE_DEFINITION_URL_V1}/api/test/triggers/webhook`;
export const WORKFLOW_TRIGGERS_TEST_POLLING_HTTP = `${RULE_DEFINITION_URL_V1}/api/test/triggers/polling/http`;
export const WORKFLOW_TRIGGERS_TEST_POLLING_SHEETS = `${RULE_DEFINITION_URL_V1}/api/test/triggers/polling/google-sheets`;

// Workflow Service Endpoints
export const WORKFLOW_ACTIVATE = (workflowId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/workflows/${workflowId}/activate`;
export const WORKFLOW_TRIGGERS_STATUS = `${RULE_DEFINITION_URL_V1}/api/triggers`;
export const WORKFLOW_TRIGGERS_STATUS_ALL = `${RULE_DEFINITION_URL_V1}/api/triggers/status`;
export const WORKFLOW_EXECUTE_MANUALLY = (workflowId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/playbooks/${workflowId}/trigger-manual`;
export const WORKFLOW_UPCOMING_SCHEDULES = `${RULE_DEFINITION_URL_V1}/api/triggers/schedule/upcoming`;

// Polling Service Endpoints
export const WORKFLOW_GMAIL_SEARCH = `${RULE_DEFINITION_URL_V1}/api/gmail/search`;
export const WORKFLOW_GOOGLE_SHEETS_READ = `${RULE_DEFINITION_URL_V1}/api/google-sheets/read`;
export const WORKFLOW_GOOGLE_SHEETS_METADATA = `${RULE_DEFINITION_URL_V1}/api/google/sheets/metadata`;

// Google Calendar node — config-panel helpers. Workflow execution does not use
// these; it goes through /api/platform/execute like every other node.
export const WORKFLOW_GOOGLE_CALENDAR_LIST = `${RULE_DEFINITION_URL_V1}/api/google-calendar/calendars`;
export const WORKFLOW_GOOGLE_CALENDAR_EVENTS_LIST = `${RULE_DEFINITION_URL_V1}/api/google-calendar/events/list`;
export const WORKFLOW_GOOGLE_CALENDAR_CREDENTIAL_TEST = `${RULE_DEFINITION_URL_V1}/api/google-calendar/credential/test`;
export const WORKFLOW_SLACK_MESSAGES = `${RULE_DEFINITION_URL_V1}/api/slack/messages`;

// Credential Management Service Endpoints
export const CREDENTIAL_MANAGEMENT_BASE = `${RULE_DEFINITION_URL_V1}/api/credential-management`;
export const CREDENTIAL_MANAGEMENT_TYPES = `${RULE_DEFINITION_URL_V1}/api/credential-management/types`;
export const CREDENTIAL_MANAGEMENT_TYPE_SCHEMA = (type: string) =>
  `${RULE_DEFINITION_URL_V1}/api/credential-management/types/${type}/schema`;
export const CREDENTIAL_MANAGEMENT_BY_ID = (id: string) =>
  `${RULE_DEFINITION_URL_V1}/api/credential-management/${id}`;
export const CREDENTIAL_MANAGEMENT_TEST = (id: string) =>
  `${RULE_DEFINITION_URL_V1}/api/credential-management/${id}/test`;
export const CREDENTIAL_MANAGEMENT_USAGE = (id: string) =>
  `${RULE_DEFINITION_URL_V1}/api/credential-management/${id}/usage`;
export const CREDENTIAL_MANAGEMENT_USAGE_SUMMARY = `${RULE_DEFINITION_URL_V1}/api/credential-management/usage/summary`;
export const CREDENTIAL_MANAGEMENT_USAGE_TRACK = `${RULE_DEFINITION_URL_V1}/api/credential-management/usage/track`;
export const MILLER_HEIMAN_ROLE_BASE_URL = `${REACT_APP_BASE_API_FILTER_URL}/customer-miller-heiman-role`;

// Execution Logs Endpoints
export const EXECUTION_LOGS_LIST = `${RULE_DEFINITION_URL_V1}/api/frontend/executions`;
export const EXECUTION_LOG_DETAILS = (executionId: string) =>
  `${RULE_DEFINITION_URL_V1}/api/frontend/executions/${executionId}`;

export const GET_RETRY_SALES_NAV_API = `${REACT_APP_BASE_API_FILTER_URL}/v2/chrome-extension/get-retry-sales-nav`;
export const ENRICHMENT_LOGS_LINKEDIN_FILTER_API = `${REACT_APP_BASE_API_FILTER_URL}/v1/contacts/enrichment/logs/linkedin-sources?key=`;
export const GET_JOB_TITLES_MILLER_HEIMAN = `${REACT_APP_BASE_API_FILTER_URL}/filter/contact`;

// Workflow Context API Endpoints (Rule Definition Service)
export const WORKFLOW_CONTEXT_BASE_URL = `${RULE_DEFINITION_URL_V1}/api/workflow/context`;
export const GET_WORKFLOW_CONTEXT = (workflowId: string, nodeId: string) =>
  `${WORKFLOW_CONTEXT_BASE_URL}/${workflowId}/${nodeId}`;
export const GET_WORKFLOW_NODE_CONTEXT = (workflowId: string, nodeId: string, tenantId: string) =>
  `${WORKFLOW_CONTEXT_BASE_URL}/${workflowId}/${nodeId}?tenantId=${tenantId}`;
export const GET_WORKFLOW_AVAILABLE_VARIABLES = (workflowId: string, tenantId: string) =>
  `${WORKFLOW_CONTEXT_BASE_URL}/${workflowId}/variables?tenantId=${tenantId}`;
export const GET_WORKFLOW_NODE_DATA = (workflowId: string, nodeId: string, tenantId: string) =>
  `${WORKFLOW_CONTEXT_BASE_URL}/${workflowId}/node/${nodeId}/data?tenantId=${tenantId}`;
export const VALIDATE_WORKFLOW_EXPRESSION = `${RULE_DEFINITION_URL_V1}/api/workflow/expression/validate`;
export const PREVIEW_WORKFLOW_EXPRESSION = `${RULE_DEFINITION_URL_V1}/api/workflow/expression/preview`;

// N8N-Style Auto-Save Workflow API Endpoints
export const WORKFLOW_AUTO_SAVE_BASE_URL = `${RULE_DEFINITION_URL_V1}/api/workflow/auto-save`;
export const AUTO_SAVE_WORKFLOW = (workflowId: string) =>
  `${WORKFLOW_AUTO_SAVE_BASE_URL}/${workflowId}`;
export const CREATE_AUTO_SAVE_WORKFLOW = `${WORKFLOW_AUTO_SAVE_BASE_URL}`;
export const GET_WORKFLOW_VERSION = (workflowId: string) =>
  `${WORKFLOW_AUTO_SAVE_BASE_URL}/${workflowId}/version`;
export const CHECK_WORKFLOW_CONFLICT = (workflowId: string, versionId: string) =>
  `${WORKFLOW_AUTO_SAVE_BASE_URL}/${workflowId}/check-conflict?versionId=${versionId}`;
export const RESOLVE_WORKFLOW_CONFLICT = (workflowId: string) =>
  `${WORKFLOW_AUTO_SAVE_BASE_URL}/${workflowId}/resolve-conflict`;

// Workflow Partial Execution API Endpoints (Backend-Driven)
export const WORKFLOW_PARTIAL_EXECUTION_BASE_URL = `${RULE_DEFINITION_URL_V1}/api/workflow/execution`;
export const EXECUTE_WORKFLOW_PARTIAL = (workflowId: string) =>
  `${WORKFLOW_PARTIAL_EXECUTION_BASE_URL}/${workflowId}/partial`;
export const GET_EXECUTION_CONTEXT = (workflowId: string, nodeId: string) =>
  `${WORKFLOW_PARTIAL_EXECUTION_BASE_URL}/${workflowId}/context/${nodeId}`;
export const GET_EXECUTION_RUN_DATA = (workflowId: string, executionId: string) =>
  `${WORKFLOW_PARTIAL_EXECUTION_BASE_URL}/${workflowId}/executions/${executionId}/run-data`;
export const GET_NODE_EXECUTION_DATA = (workflowId: string, nodeId: string) =>
  `${WORKFLOW_PARTIAL_EXECUTION_BASE_URL}/${workflowId}/nodes/${nodeId}/execution-data`;
export const AI_AGENT_NODE_PREVIEW = (workflowId: string, nodeId: string) =>
  `${WORKFLOW_PARTIAL_EXECUTION_BASE_URL}/${workflowId}/node/${nodeId}/preview`;
export const GET_DATABASE_ACCOUNT_DETAILS_BY_ID = `${MDQS_BASEURL}/v1/accounts/details`;
export const GET_DATABASE_CONTACT_DETAILS_BY_ID = `${MDQS_BASEURL}/v1/contacts/details`;
export const GET_LISTS_BY_LINKEDIN_ID = `${REACT_APP_BASE_API_FILTER_URL}/customer_lists/get-list-details-by-linkedin-or-id`;
export const GET_SEQUENCES_BY_LINKEDIN_ID = `${REACT_APP_BASE_API_FILTER_URL}/customer_lists/get-sequence-details-by-linkedin-or-id`;
export const GET_CONTACT_DETAILS_LINKEDIN_ID = `${REACT_APP_BASE_API_FILTER_URL}/contact-details/get-enrichment-details`;
export const GET_ACCOUNT_ICP_DETAILS = `${REACT_APP_BASE_API_FILTER_URL}/account/getAccountFitment`;
export const get_COMPANIES_FOR_TAL_SEARCH_FILTER = (clientId: string) =>
  `${REACT_APP_BASE_API_FILTER_URL}/filter/account/${clientId}/getOrg?page_size=25&searchText=`;
export const get_COMPANIES_FOR_DBS_SEARCH_FILTER = `${MDQS_BASEURL}/v1/search/filters/companies?databaseName=sprouts&page=1&page_size=50&search_text=`;
export const get_COMPANIES_FOR_WAL_SEARCH_FILTER = (clientId: string) =>
  `${REACT_APP_BASE_API_FILTER_URL}/filter/websiteVisit/${clientId}/getOrganizationForWebsiteVisit?page_size=25&searchText=`;
export const GET_WATERFALL_DEFAULT_SOURCES = `${MDQS_BASEURL}/v1/enrichment/default_sources`;
export const ENRICH_DEPARTMENT_HEADCOUNT_GROWTH = `${REACT_APP_BASE_API_FILTER_URL}/api/department-enrichment/enrich-company`;
export const ENRICH_COMPANY_HEADCOUNT_GROWTH = `${REACT_APP_BASE_API_FILTER_URL}/api/company-headcount/enrich-company`;
export const HEADCOUNT_DEPARTMENT_POLLING = `${REACT_APP_BASE_API_FILTER_URL}/api/department-enrichment/polling`;
export const HEADCOUNT_COMPANY_POLLING = `${REACT_APP_BASE_API_FILTER_URL}/api/company-headcount/polling`;
export const GET_HEADCOUNT_DEPARTMENTS = `${REACT_APP_BASE_API_FILTER_URL}/api/department-configuration/options`;
export const GET_DEPARTMENT_HEADCOUNT_CONFIG = `${REACT_APP_BASE_API_FILTER_URL}/api/department-configuration/config`;
export const DEPARTMENT_HEADCOUNT_ENRICH = `${REACT_APP_BASE_API_FILTER_URL}/api/department-configuration/config-and-enrich`;
export const COMPANY_HEADCOUNT_ENRICH = `${REACT_APP_BASE_API_FILTER_URL}/api/company-headcount/config-and-enrich`;

// Trend Score — Scoring & Intelligence (Smart Column)
export const TREND_SCORE_LIST       = `${REACT_APP_BASE_API_FILTER_URL}/v1/trend-score/trendScoreConfigs`;
export const TREND_SCORE_CREATE     = `${REACT_APP_BASE_API_FILTER_URL}/v1/trend-score/createTrendScoreConfig`;
export const TREND_SCORE_GET_CONFIG = (pk: number | string) => `${REACT_APP_BASE_API_FILTER_URL}/v1/trend-score/${pk}/config`;
export const TREND_SCORE_UPDATE     = (pk: number | string) => `${REACT_APP_BASE_API_FILTER_URL}/v1/trend-score/${pk}/update`;
export const TREND_SCORE_ACTIVATE   = (pk: number | string) => `${REACT_APP_BASE_API_FILTER_URL}/v1/trend-score/${pk}/activate`;
export const TREND_SCORE_RESCORE    = (pk: number | string) => `${REACT_APP_BASE_API_FILTER_URL}/v1/trend-score/${pk}/rescore`;
export const TREND_SCORE_DELETE     = (pk: number | string) => `${REACT_APP_BASE_API_FILTER_URL}/v1/trend-score/${pk}/config`;
export const SET_ACCOUNTS_ENRICHMENT_SOURCES = `${MDQS_BASEURL}/v1/accounts/field_enrichment/config`;
export const ENRICH_ACCOUNTS_FIELDS_TAL = `${REACT_APP_BASE_API_FILTER_URL}/v1/companies/enrich`;
export const ENRICH_ANNUAL_REVENUE_POLLING = `${REACT_APP_BASE_API_FILTER_URL}/v1/companies/enrichPoll`;
export const ENRICH_CONTACT_POLLING = `${REACT_APP_BASE_API_FILTER_URL}/v2/contacts/enrichPoll`;

// BYOK Endpoints
export const BYOK_BASE_ENDPOINT = `${MDQS_BASEURL}/v1/enrichments/byok_sources`;
export const GET_ASK_AI_SIGNAL_DATA = `${REACT_APP_BASE_API_FILTER_URL}/ask-ai/get-all-configurations`;
export const GET_ASK_AI_CUSTOMER_CONFIGURATION = `${REACT_APP_BASE_API_FILTER_URL}/ask-ai/get-customer-configuration`;
export const GET_ASK_AI_MODELS = `${REACT_APP_BASE_API_FILTER_URL}/ask-ai/get-ai-models`;
export const DELETE_ASK_AI_CONFIG = `${REACT_APP_BASE_API_FILTER_URL}/ask-ai/delete`;
export const SAVE_ASK_AI_CONFIG = `${REACT_APP_BASE_API_FILTER_URL}/ask-ai/save`;
export const SAVE_ASK_AI_CONFIG_BATCH = `${REACT_APP_BASE_API_FILTER_URL}/ask-ai/save/batch`;
export const UPDATE_ASK_AI_CONFIG = `${REACT_APP_BASE_API_FILTER_URL}/ask-ai/update`;
export const GET_ASK_AI_FIELDS = `${REACT_APP_BASE_API_FILTER_URL}/ask-ai/fields`;
export const RUN_ASK_AI_CELL = `${REACT_APP_BASE_API_FILTER_URL}/ask-ai/enrich`;
export const REFINE_ASK_AI_PROMPT = `${ML_BASE_URL}/refinecustomprompt/refineprompt`;
export const ASK_AI_DATA_POLLING = `${REACT_APP_BASE_API_FILTER_URL}/ask-ai/polling-status`;
export const PREVIEW_ASK_AI_DATA = `${ML_BASE_URL}/askaigenerator/generate`;
export const GET_ASK_AI_SUGGESTED_COLUMN_NAME = `${ML_BASE_URL}/askaigenerator/suggestcolumnname`;
export const GET_SIGNAL_LIBRARY_COUNT = `${REACT_APP_BASE_API_FILTER_URL}/v1/aisignal/preconfigured-signals-count`;

// Account Enrichment Logs Endpoints
export const ENRICHMENT_LOGS_ACCOUNTS_TABLE_API = `${REACT_APP_BASE_API_FILTER_URL}/v1/companies/enrichment/logs`;
export const ENRICHMENT_LOGS_ACCOUNTS_EXPORT_API = `${REACT_APP_BASE_API_FILTER_URL}/v1/companies/enrichment/logs/export`;
export const ENRICHMENT_LOGS_ACCOUNTS_USERS_FILTER_API = `${REACT_APP_BASE_API_FILTER_URL}/v1/companies/enrichment/logs/user_filter?key=`;
export const ENRICHMENT_LOGS_ACCOUNTS_ENRICHMENT_TYPE_FILTER_API = `${REACT_APP_BASE_API_FILTER_URL}/v1/companies/enrichment/logs/field-type`;
export const ENRICHMENT_LOGS_CONTACTS_ENRICHMENT_TYPE_FILTER_API = `${REACT_APP_BASE_API_FILTER_URL}/v1/contacts/enrichment/logs/field-type`;

// Contact Duplicates Endpoints
export const GET_DUPLICATE_CONTACTS_API_BY_ID = `${REACT_APP_BASE_API_FILTER_URL}/fetch/duplicate/contacts`;
export const GET_DUPLICATE_CONTACTS_VIEW_ALL_API = `${REACT_APP_BASE_API_FILTER_URL}/fetch/duplicate/contacts/grouped`;
export const RESOLVE_DUPLICATE_CONTACTS_API = `${REACT_APP_BASE_API_FILTER_URL}/resolve/duplicate/contacts`;
export const GET_DUPLICATE_CONTACTS_VIEW_ALL_API_BY_LINKEDIN = `${REACT_APP_BASE_API_FILTER_URL}/fetch/duplicate/contacts/grouped/linkedin`;
export const RESOLVE_DUPLICATE_CONTACTS_API_BY_LINKEDIN = `${REACT_APP_BASE_API_FILTER_URL}/resolve/duplicate/contacts/linkedin`;

export const NOTIFICATIONS_CONFIG_EVENTS_URL = `${NOTIFICATIONS_BASE_URL}/v1/preferences/events`;
export const NOTIFICATIONS_CONFIG_CHANNELS_URL = `${NOTIFICATIONS_BASE_URL}/v1/preferences/channels`;
export const NOTIFICATIONS_CONFIG_PREFERENCES_URL = `${NOTIFICATIONS_BASE_URL}/v1/preferences`;
export const NOTIFICATIONS_CONFIG_TOGGLE = `${NOTIFICATIONS_BASE_URL}/v1/users`;

export const NOTIFICATIONS_ALERTS_STREAM_URL = `${NOTIFICATIONS_BASE_URL}/v1/user/notifications/stream`;
export const NOTIFICATIONS_ALERTS_LIST_URL = `${NOTIFICATIONS_BASE_URL}/v1/user/notifications`;
export const NOTIFICATIONS_ALERTS_UNREAD_COUNT_URL = `${NOTIFICATIONS_BASE_URL}/v1/user/notifications/unread-count`;
export const NOTIFICATIONS_ALERTS_READ_URL = `${NOTIFICATIONS_BASE_URL}/v1/user/notifications`;
export const NOTIFICATIONS_ALERTS_READ_ALL_URL = `${NOTIFICATIONS_BASE_URL}/v1/user/notifications/read-all`;
export const NOTIFICATIONS_ALERTS_AFTER_URL = `${NOTIFICATIONS_BASE_URL}/v1/user/notifications/after`;

// Get List Id based on list name
export const GET_LIST_ID_BY_LIST_NAME = `${REACT_APP_BASE_API_FILTER_URL}/accountList/getListIdByListName`;

// Company Logo URL Generator
export const getCompanyLogo = (domain: string) => {
  return `${LOGO_BASE_URL}/${domain}`;
};

export const MARK_AS_CHAMPION_CONTACT = `${REACT_APP_BASE_API_FILTER_URL}/champion/mark-as-champion`;
export const UPDATE_JOB_CHANGE_CONTACT = `${REACT_APP_BASE_API_FILTER_URL}/champion/updateJobChange`;

export const VERIFY_SIGN_IN_USER = `${BASE_API_URL}/verify-sign-in`;
export const CONTACT_SALES_API = `${REACT_APP_BASE_API_FILTER_URL}/v1/credit/salesInquiryEmail`;
export const GOOGLE_SIGNUP_API = `${BASE_API_URL}/sign-up-Oauth`;
export const RESET_CREDIT_BALANCE_API = `${REACT_APP_BASE_API_FILTER_URL}/v1/credit/resetCreditBalance`;
export const TRAIL_PERIOD_INTEGRATION_ENABLE_API = `${REACT_APP_BASE_API_FILTER_URL}/v1/credit/enableIntegration`;

export const ENGAGEMENT_SCORE_TRIGGER_API = `${REACT_APP_BASE_API_FILTER_URL}/api/engagement/cold-start`;
export const GET_PARENT_CHILD_ACCOUNTS = `${MDQS_BASEURL}/v1/accounts/enrich/bulk/parent-child`;

export const GET_MDQS_SIMILAR_COMPANIES = `${MDQS_BASEURL}/v1/accounts/similar_companies`;
export const GET_CONTACTS_JOB_STATUS_API = `${REACT_APP_BASE_API_FILTER_URL}/v1/contacts/refresh/logs`;
export const GET_DATA_BY_SEARCH_PROMPT = `${REACT_APP_BASE_API_FILTER_URL}/get-data-by-search-prompt`;

export const IMPORT_SALES_NAV_CONTACTS_API = `${MDQS_BASEURL}/v1/target_profiles/contacts/salesnav`
export const SALES_NAV_JOB_STATUS_POLL_API = `${MDQS_BASEURL}/v1/target_profiles/contacts/salesnav/bulk/status`

export const export_WEBSITE_VISITS_ANALYTICS = (
  customerId: string,
  fromDate: string,
  toDate: string,
) =>
  `${WEB_TRACK_URL}/v1/iplookups/${customerId}/export?fromIpHitTime=${encodeURIComponent(fromDate)}&toIpHitTime=${encodeURIComponent(toDate)}`;

// Credit Per User Management APIs
export const GET_ALL_CUSTOMER_USERS_WITH_CREDIT_USAGE = `${CREDITS_BASE_URL}/v1/customers/users`;
export const UPDATE_CUSTOMER_USER_CREDIT_DETAILS = `${CREDITS_BASE_URL}/v1/customers/users`;
export const UPDATE_BULK_USER_CREDIT_POLICY = `${CREDITS_BASE_URL}/v1/customers/users/policy`;

export const QUALIFY_LINKEDIN_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/v1/contacts/verify-linkedinurl`;

// DB Search Find more and Refresh data APIs
export const CONTACT_DISCOVER_MORE = `${MDQS_BASEURL}/v1/contacts/discover-more`;
export const CONTACT_DISCOVER_MORE_JOBS = `${MDQS_BASEURL}/v1/contacts/discover-more/jobs`;
export const contact_discover_more_job_detail = (jobId: string) =>
  `${MDQS_BASEURL}/v1/contacts/discover-more/jobs/${jobId}`;
export const contact_discover_more_job_contacts = (jobId: string) =>
  `${MDQS_BASEURL}/v1/contacts/discover-more/jobs/${jobId}/contacts`;
export const CONTACT_REFRESH_JOB_CREATE = `${MDQS_BASEURL}/v1/contacts/refresh`;
export const contact_refresh_job_detail = (jobId: string) =>
  `${MDQS_BASEURL}/v1/contacts/refresh/jobs/${jobId}`;

export const GET_IMPORT_LOGS_STATUS = `${REACT_APP_BASE_API_FILTER_URL}/logs/status`;
export const UPDATE_CUSTOMISE_EXPORT_HEADERS = `${REACT_APP_BASE_API_FILTER_URL}/update/export/layout`;
export const EXPORT_SELECTED_ACCOUNT_HEADERS = `${REACT_APP_BASE_API_FILTER_URL}/exportSelectedColumnsForAccounts`;
export const EXPORT_SELECTED_CONTACT_HEADERS = `${REACT_APP_BASE_API_FILTER_URL}/exportSelectedColumnsForContacts`;
export const GET_ALL_EXPORTABLE_COLUMNS = `${REACT_APP_BASE_API_FILTER_URL}/customized/export/headers/entity`

export const CONTACT_ENRICHMENT_IN_PROGRESS_LOGS = `${REACT_APP_BASE_API_FILTER_URL}/v1/contacts/enrichment/in-progress-logs`;
export const ACCOUNT_ENRICHMENT_IN_PROGRESS_LOGS = `${REACT_APP_BASE_API_FILTER_URL}/v1/companies/enrichment/in-progress-logs`;

export const INTEGRATION_LOGS_LIST_API = `${REACT_APP_BASE_API_FILTER_URL}/integration-logs/get-logs`;
export const INTEGRATION_LOGS_DETAIL_API = `${REACT_APP_BASE_API_FILTER_URL}/integration-logs/get-detail-logs`;


// Champions Tracking V2 APIs
export const UPDATE_CHAMPIONS_REFRESH_CYCLES = `${REACT_APP_BASE_API_FILTER_URL}/champion/configure-interval`;
export const GET_CHAMPIONS_REFRESH_CYCLES = `${REACT_APP_BASE_API_FILTER_URL}/champion/fetch-interval`;
export const GET_CHAMPIONS_V2_CONTACTS = `${REACT_APP_BASE_API_FILTER_URL}/champion/monitoring-status`;
export const INSTANT_TRIGGER_CHAMPIONS_MONITORING = `${REACT_APP_BASE_API_FILTER_URL}/champion/trigger-monitoring/contacts`;
export const REMOVE_CONTACTS_FROM_CHAMPIONS_V2 = `${REACT_APP_BASE_API_FILTER_URL}/champion/remove`;

export const GET_DISCOVER_WITH_AI_PREVIOUS_USER_QUERIES = `${REACT_APP_BASE_API_FILTER_URL}/api/v1/user-search-queries`;
export const GET_DATA_BY_SEARCH_PROMPT_V2 = `${REACT_APP_BASE_API_FILTER_URL}/v1/get-data-by-search-prompt`;
export const GET_MOVE_TO_TAL_LOGS = `${REACT_APP_BASE_API_FILTER_URL}/logs/getMTLLogs`;

export const EXCLUDE_ALLOWED_WEBSITE_REVEAL_DOMAINS = `${REACT_APP_BASE_API_FILTER_URL}/api/v1/exclude-allowed-website-reveal-domains`;


export const WATERFALL_EMAIL_PHONE_VALIDATOR_CONFIG = `${MDQS_BASEURL}/v1/contacts/field_verification/config`;

// Sequence Enrollment
export const SEQUENCE_ENROLLMENT_CONFIG_SAVE = `${REACT_APP_BASE_API_FILTER_URL}/api/v1/customer-global-config/save`;
export const SEQUENCE_ENROLLMENT_CONFIG_GET = `${REACT_APP_BASE_API_FILTER_URL}/api/v1/customer-global-config/get`;
export const GET_AVAILABLE_CONTACTS_COUNT_FOR_ENRICHMENT = `${REACT_APP_BASE_API_FILTER_URL}/v1/contacts/enrichment/availability-count`;

export const UNIQUE_PAGE_VISITS_DATES_API = `${WEB_TRACK_URL}/v1/iplookups/domains/visitDates`;

export const GET_SOURCE_CONTACTS_ACCOUNTS_BASED_ON_DOMAIN_AND_LINKEDIN = `${REACT_APP_BASE_API_FILTER_URL}/account/getAccountByDomainOrLinkedin`;
// extraInfoId — primary key of the account's CustomerCompanyExtraInfo record
export const ACCOUNT_CUSTOM_FIELD_UPDATE = (extraInfoId: number | string) =>
  `${REACT_APP_BASE_API_FILTER_URL}/account/custom-field/${extraInfoId}`;

// id — primary key of the Contacts record
export const CONTACT_FIELD_UPDATE = (id: number | string) =>
  `${REACT_APP_BASE_API_FILTER_URL}/contact-details/field/${id}`;

// ---------------------------------------------------------------------------
// AKMS — API Key Management Service.
//
// Backs the super-admin "API Configuration" tab: which gateway APIs a customer may
// call, the tier that sets their throughput, and what they have used so far.
// ---------------------------------------------------------------------------

/**
 * Platform API registry: every gateway API and what it is for.
 *
 * No longer carries limits that anyone enforces. Rate limiting is per customer by tier, so this
 * only names each endpoint — which is what attributes usage to it in the usage report.
 */
export const AKMS_API_REGISTRY = `${AKMS_BASE_URL}/api/apis`;

// --- Tiers -----------------------------------------------------------------
//
// A tier is the whole rate-limit configuration: one allowance shared across every key, user and
// endpoint on the account. Writes are Superadmin / Customer Support only.

/** Every tier. `?include_inactive=true` also returns retired ones. */
export const AKMS_TIERS = `${AKMS_BASE_URL}/api/tiers`;

/** One tier, by name. Also the edit and delete target. */
export const AKMS_TIER = (tierName: string) =>
  `${AKMS_BASE_URL}/api/tiers/${encodeURIComponent(tierName)}`;

/** The tier in force for a customer. GET to read it, PUT to move them to another one. */
export const AKMS_CUSTOMER_TIER = (customerRef: string) =>
  `${AKMS_BASE_URL}/api/tiers/customer/${encodeURIComponent(customerRef)}`;

/** Every period this customer has spent on a tier, newest first. */
export const AKMS_CUSTOMER_TIER_HISTORY = (customerRef: string) =>
  `${AKMS_BASE_URL}/api/tiers/customer/${encodeURIComponent(customerRef)}/history`;

/**
 * One customer's request volume over a date range, from Elasticsearch: the total plus an
 * API-wise breakdown. `from` and `to` take ISO timestamps or date math such as `now-30d`.
 *
 * Superadmin / Customer Support only — customer_ref is a free parameter, so anyone who reaches
 * this can read any tenant's traffic.
 */
export const AKMS_CUSTOMER_USAGE = (customerRef: string) =>
  `${AKMS_BASE_URL}/api/stats/customer/${encodeURIComponent(customerRef)}`;

/** A tenant's API keys. Scoped server-side to the caller's tenant — no customer id is passed. */
export const AKMS_API_KEYS = `${AKMS_BASE_URL}/api/keys`;

export const AKMS_API_KEY_GENERATE = `${AKMS_BASE_URL}/api/keys/generate`;

export const AKMS_API_KEY_REVOKE = (keyId: string) =>
  `${AKMS_BASE_URL}/api/keys/${encodeURIComponent(keyId)}/revoke`;

export const AKMS_API_KEY_ACTIVATE = (keyId: string) =>
  `${AKMS_BASE_URL}/api/keys/${encodeURIComponent(keyId)}/activate`;

/** Soft delete: the key stops working and leaves the list, but its history is kept. */
export const AKMS_API_KEY_DELETE = (keyId: string) =>
  `${AKMS_BASE_URL}/api/keys/${encodeURIComponent(keyId)}`;

/** Who created, revoked, re-activated or deleted this key, and when. */
export const AKMS_API_KEY_EVENTS = (keyId: string) =>
  `${AKMS_BASE_URL}/api/keys/${encodeURIComponent(keyId)}/events`;

/** Replaces a key's secret. The old value stops working immediately. */
export const AKMS_API_KEY_REGENERATE = (keyId: string) =>
  `${AKMS_BASE_URL}/api/keys/${encodeURIComponent(keyId)}/regenerate`;
